// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #fff;
  --black: #000;
  --primary-black: rgba(0, 0, 0, 0.12);
  --secondary-black: #212529;
  --primary-blue-color: #293b83;
  --secondary-blue-color: #3e56bf;
  --dark-blue: #0e527d;
  --border-lines: #e1e6e9;
  --light-blue: #1a87cb;
  --very-dark-blue: #24397a;
  --very-dark-elephant-gray: #8f7777;
  --elephant-dark-grey: #aaa;
  --light-eleph-light-grey: #e5f0ff;
  --disabled-light-grey: #e9ecef;
  --very-light-grey: #d1d1d1;
  --v-grey-light: #eee;
  --table-row-bg-light-grey: #fafafa;
  --box-shadow-color: #8b8084;
  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);
  /* linear-gradient(90deg, #031978, #3e56bf)  */
  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);
  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);
  --light-blue-gradient-angle: linear-gradient(90deg,
      #46a4cf 8%,
      #2f324f 86.9%);
  --green-gradient: linear-gradient(73.1deg,
      rgba(34, 126, 34, 1) 8%,
      rgba(99, 162, 17, 1) 86.9%);
  --roboto-font-family: "Plus Jakarta Sans", sans-serif;
  /* Gmail theme */
  --backclr: #e0e0ea;
  --gblack: #f6f8fc;
  --gsbgcolor: #eaf1fb;
  --bgactive-color: #d3e3fd;
  --active-color: #001d35;
  --txt-color2: #393a3f;
  --icon-color: #5f6368;
  --background-color: #f8f9fa;
  --border-color: #d1d5db;
}

body {
  font-family: "Plus Jakarta Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Plus Jakarta Sans", sans-serif;
}

#page-topbar .logo-lg.barath-logo {
  margin: 0 auto;
}

/* #page-topbar .logo-sm.favicon-logo{
    margin-left: -10px;
} */
#page-topbar {
  background: var(--gblack);
}

.vertical-menu {
  background: var(--gblack);
}

#sidebar-menu ul li a {
  color: var(--active-color);
}

#sidebar-menu ul li a:hover {
  color: var(--active-color);
}

.mm-active>a {
  color: var(--active-color);
  background: var(--bgactive-color);
}

.mm-active>a i {
  color: var(--active-color) !important;
}

#sidebar-menu ul li a {
  font-size: 16px;
}

#sidebar-menu > ul > li > a {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 46px;
  padding: 12px 42px 12px 20px;
  line-height: 1.25;
}

#sidebar-menu ul li a i {
  font-size: 18px;
  color: var(--active-color);
}

#sidebar-menu > ul > li > a i {
  flex: 0 0 24px;
  min-width: 24px;
  margin-right: 10px;
  line-height: 1;
}

#sidebar-menu > ul > li > a span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#sidebar-menu .has-arrow::after {
  position: absolute;
  top: 50%;
  right: 18px;
  float: none;
  margin: 0;
  line-height: 1;
  transform: translateY(-50%);
}

#sidebar-menu .mm-active > .has-arrow::after {
  transform: translateY(-50%) rotate(-180deg);
}

#sidebar-menu ul li a i:hover {
  color: var(--active-color) !important;
}

#sidebar-menu ul li ul.sub-menu li a {
  color: var(--txt-color2);
}

#sidebar-menu ul li a:hover i {
  color: var(--gblack);
}

/* #sidebar-menu ul li a i {
  color: var(--bs-sidebar-dark-menu-item-active-color);
} */

.header-item {
  color: var(--icon-color);
}

.header-item:hover {
  color: var(--icon-color);
}

.noti-icon i {
  /* color: var(--icon-color); */
  color: var(--active-color);
}

.navbar-brand-box {
  background: transparent;
  text-align: left;
}

.noti-icon.slider-icon i {
  font-size: 20px;
  color: #444746;
}

.app-search .form-control {
  background-color: var(--gsbgcolor);
  height: 46px;
}

/* 
.navbar-brand-box .barath-logo,.favicon-logo {
   
} */
.linear-output .mainbtn {
  color: #000;
  background-color: var(--backclr);
}

.linear-output .mainbtn:hover {
  color: #000;
  background-color: var(--blue-gradient-angle) !important;
}

.mainbtn {
  background-color: var(--backclr);
  border: 0;
  /* box-shadow: 5px 5px 10px #8f7777; */
  /* font-family: Mukta, sans-serif; */
  font-size: 15px;
  /* font-weight: 700; */
  padding: 7px 18px;
  /* text-transform: uppercase; */
  border-radius: 4px;
  /* color: #fff; */
  margin-left: 4px;
}

.btn-primary {
  background: var(--blue-gradient-right);
  /*  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb); */
  border: 0;
  /* box-shadow: 5px 5px 10px #8f7777; */
  /* font-family: Mukta, sans-serif; */
  font-size: 15px;
  /* font-weight: 700; */
  padding: 7px 18px;
  /* text-transform: uppercase; */
  border-radius: 4px;
  color: #fff;
}

.btn-primary:hover {
  background: var(--blue-gradient-angle);
  font-size: 15px;
  color: var(--white);
}

.mainbtn:hover {
  background-image: var(--blue-gradient-angle);
  color: var(--white);
}

.right-btn .mainbtn {
  background-color: var(--white);
}

.right-btn .mainbtn {
  background-color: var(--backclr);
  color: var(--black);
}

.right-btn .mainbtn:hover {
  color: var(--white);
}

/* nav tabs */

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  /* border: solid #e5e7eb; */
  /* border-width: 0 0 2px 0; */
  /* border-color: transparent transparent #e5e7eb transparent; */
  /* background: #ececf1 !important;  */
  color: #6b7280;
  padding: 1.25rem;
  /* font-weight: 700; */
  /* border-top-right-radius: 6px; */
  /* border-top-left-radius: 6px; */
  /* transition: box-shadow 0.2s; */
  /* margin: 0 0 -2px 0; */
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {
  /* outline: 0 none; */
  /* outline-offset: 0; */
  /* box-shadow: inset 0 0 0 0.2rem #c7d2fe; */
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border-radius: none;
  color: var(--white);
  font-size: var(--bs-btn-font-size);
}

.p-tabview .p-tabview-nav {
  /* // background: #ececf1; */
  border: 1px solid #e5e7eb;
  border-width: 0 0 2px 0;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {
  border: none;
  box-shadow: none;
  background-image: linear-gradient(90deg, #0e527d, #1a87cb) !important;
  border-radius: 0px;
}

.accordian-menu .p-tabview-panels {
  display: none;
}

.p-tabview-title {
  font-size: 15px;
  font-weight: 400;
  color: #000;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border-color: transparent !important;
  color: var(--white);
  padding: 7px 18px;
  margin-right: 10px;
  border-radius: 4px;
  margin-bottom: 0px;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {
  color: var(--white);
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 8px 18px;
  margin-right: 10px;
}

/* // --bs-btn-padding-x: 0.75rem;
  //     --bs-btn-padding-y: 0.375rem; */

.p-tabview .p-tabview-nav {
  border: none;
  border-width: 0 0 2px 0;
}

.p-tabview .p-tabview-nav {
  background-color: transparent !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none;
  background: none;
}

.p-tabview .p-tabview-nav .p-tabview-closable span.p-tabview-close-icon {
  font-size: 0.3rem;
}

.p-component {
  font-family: "Plus Jakarta Sans", sans-serif;
  /* font-feature-settings: var(--font-feature-settings, normal); */
  font-size: 15px;
  font-weight: normal;
}

.action-items .p-dropdown span {
  font-family: "Plus Jakarta Sans", sans-serif;
}

.p-tabview-nav {
  padding-left: 0px;
}

/* nav tabs ends */

.vertical-collpsed .navbar-brand-box {
  width: 172px !important;
}

.navbar-brand-box {
  width: 196px;
}

.btn-secondary:active,
.btn-secondary:hover {
  background-color: var(--backclr);
}

.allact-tabs .card1 {
  background: none;
  margin-bottom: 0px;
}

.allact-tabs .card-body1 {
  padding-bottom: 0px;
  padding-left: 0px;
}

.allact-tabs .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: var(--bs-nav-pills-link-active-color);
  /* background-color: var(--bs-nav-pills-link-active-bg); */
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
}

.allact-tabs .breadcrumb-card {
  background: var(--bs-header-bg);
  border-radius: 6px;
}

.allact-tabs .import-res-btn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
}

.p-datatable .p-datatable-tbody>tr.p-highlight {
  color: #000;
}

.p-component * {
  font-size: 15px;
}

.p-inputtext {
  padding: 7px 18px;
  border-radius: 4px;
  /* line-height: 0px; */
}

.p-inputtext::placeholder {
  color: #4b5563;
}

.p-inputtext:enabled:hover {
  border-color: none;
}

.p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: none !important;
  color: #000;
}

.p-paginator .p-dropdown {
  margin-left: 0.5rem;
  height: auto;
}

.p-inputtext:enabled:hover {
  border-color: none;
}

/* .p-dropdown-items {
  padding: 0px !important;
} */

.footer-back {
  background-color: var(--gblack);
}

.add-pad {
  padding: 8px 18px;
}

.p-datatable .p-datatable-tbody>tr>td {
  text-align: left;
}

.p-speeddial-button.p-button.p-button-icon-only {
  width: auto;
  height: auto;
  padding: 8px 14px;
  border-radius: 4px;
  background-color: #e0e0ea;
  border: none;
  color: #000;

}

.p-button:not(:disabled):hover {
  background: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
}

.p-button:focus {
  box-shadow: none
}

.p-speeddial-action {
  width: 3rem;
  height: 3rem;
  background: #ececf1 !important;
  color: #000000 !important;
}

.productdemo .p-button {
  background: #e0e0ea;
  border: none;
  padding: 8px 18px;
  font-size: 15px;
  border-radius: 4px !important;
  border: none;
  color: #000;
  font-weight: 400 !important;
}

.p-toolbar {
  background: #ececf1 !important;
  border: none !important;
  padding: 0px;
  border-radius: 0px;
  gap: 0px;
}

.p-button-label {
  font-weight: 400;
}


#sidebar-menu ul li ul.sub-menu {
  background-color: var(--white) !important;
}

#sidebar-menu ul li ul.sub-menu li a {
  padding: 9px 20px 9px 56px;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.35;
}

#sidebar-menu ul li a:hover i {
  color: #000000;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  background: transparent;
  font-family: "Plus Jakarta Sans", sans-serif;
  text-decoration: none;
}

#sidebar-menu ul li a {
  font-family: "Plus Jakarta Sans", sans-serif;
  text-decoration: none;
}


.p-dropdown {
  /* background:var(--backclr); */
  background: var(--backclr);
  border: none;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 4px;
  outline-color: transparent;
}

.p-dropdown::placeholder {
  color: #000 !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #000000;
  background: var(--white);
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #000000;
  background: var(--backclr);
}


.p-dropdown:not(.p-disabled):hover {
  /* border-color: #6366f1; */
  background-image: var(--blue-gradient-angle) !important;
  color: var(--white);
}


.p-dropdown .p-dropdown-trigger {
  color: var(--black);
}

.p-dropdown:not(.p-disabled):hover .p-dropdown .p-dropdown-trigger:hover {
  color: var(--white);
}

/* .p-datatable .p-datatable-thead>tr>th {
  padding: 1rem 8px;
} */

.page-content {
  padding: 69px calc(1.5rem / 2) 0px calc(1.5rem / 2);
  background: var(--white);
  /* margin-bottom: 100px; */
}

.icon-style {
  position: relative;
  z-index: 99;
  top: 0px;
  gap: 10px;
  left: 38px;
}

/* Lavan */

.fullform-bkclr {
  background-color: var(--background-color);
}

/* .p-tabview .p-tabview-panels {
    background-color: var(--background-color);
  } */

.fullform-head {
  font-size: 16px;
  font-weight: 500;
}


.fullform .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: 1px solid #eee;
}

.fullform .p-tabview-panels {
  padding-top: 0px;
}

.p-badge.p-badge-success {
  background-color: #6365f12e;
  color: #4b5563;
  padding: 4px 8px;
  font-weight: 500;
  font-size: 14px;
  border-radius: 30px;
}

.p-badge.p-badge-secondary {
  background-color: #64748b;
  color: var(--white);
  padding: 2px 4px;
}

.p-button.p-button-info {
  background-color: var(--backclr);
  border: none;
  color: #000;
}

.p-button.p-button-danger {
  background-color: var(--backclr);
  border: none;
  color: #000;
}

.bg-ltclr {
  background-color: #f9fafb;
}

/* .full-form{
  background-color: #;
} */

.bg-form.card {
  /* background-color: #eaf1fb75 !important; */
  border-radius: 15px;
  border: 1px solid var(--border-color);
}

.extra.bg-form {
  background-color: #eaf1fb75;
  border-radius: 15px;
}

.bg-form .p-inputtext {
  background-color: var(--white);
}

.extra .bg-form .p-inputtext {
  background-color: #eaf1fb75;
}

.bg-form .p-dropdown .p-dropdown-trigger {
  background-color: var(--white);
}


.form-btn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
}

.form-btn:hover {
  /* background-color: var(); */
  color: var(--white);
}

.drop-clr {
  background-color: #f0f6fc;
}

.drop-clr:hover {
  background-color: #f0f6fc !important;
  color: var(--black) !important;
  border: none;
}

.bg-form .p-dropdown:not(.p-disabled):hover {
  /* border-color: #6366f1; */
  background-image: none !important;
  color: var(--black) !important;
}

.bg-form .p-dropdown .p-dropdown-label.p-placeholder {
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.bg-backclr {
  background-color: #f0f6fc;
}

.bg-form .p-checkbox .p-checkbox-input {
  border: 2px solid #e6e7e9 !important;
}

.bg-form .card-title {
  font-weight: 500;
}

.bg-form h4 {
  background-color: #eaf1fb;
  padding: 10px 8px;
  border-radius: 5px;
}

.bg-form .p-datepicker-trigger {
  background-color: var(--backclr);
  color: var(--black);
  border: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.formDisable {
  opacity: 0.4;
  cursor: pointer;
}

.formEnable {
  opacity: 1;
}

.dis-none {
  display: none;
}

.dis-bloc {
  display: block;
}

.p-button {
  background-color: var(--backclr);
  border: 1px solid var(--backclr);
  color: var(--black);
  
}

/* Lavan */


/* naveen */

.p-datatable .p-datatable-tbody>tr>td {
  text-align: left;
  border: 1px solid #e5e7eb;
  border-width: 0 0 1px 0;
  /* padding: 0px 6px; */
}

.p-datatable .p-datatable-tbody>tr>td {
  text-align: start !important;
}

.p-speeddial-opened .p-speeddial-rotate {
  transform: rotate(90deg);
}

.p-tabview-title {
  line-height: 1.5;
}



/* naveen */

/* venkatlaxmi code start  */

/* laxmi */

.p-sidebar-right .p-sidebar {
  width: 30vw;
  height: 100%;
}

.sidebar .p-inputtext {
  width: 100%;
}

.sidebar .p-dropdown {
  width: 100%;
  background: transparent;
  border: none;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  /* padding: 8px 18px; */
}

.sidebar label {
  font-weight: 500;
  font-weight: 400;
}

.sidebar .sidebarbtn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none;
}

.sidebar .btn-primary.p-button.outlinebtn {
  border: 1px solid var(--dark-blue);
  color: var(--black);
  background-color: transparent;
  padding: 7px 18px;
  padding: 6px 18px;
}

.sidebar .btn-primary.p-button.outlinebtn:hover {
  color: var(--white);
}

.sidebar .p-sidebar-header {
  display: none;
  padding: 0px;
}

.p-sidebar .p-sidebar-content {
  padding: 0px;
}

.sidebar .sidebardetails {
  padding: 30px 30px;
}

.sidebar .buttons {
  margin-top: 30px;
}

.sidebar .outlinebtn.p-button:not(:disabled):hover {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--dark-blue);
  /* Background color */
  color: white;
  padding: 10px 10px;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 22px;
  font-weight: 400 !important;
  /* Adjust font size as needed */
}

.sidebar-header .close-btn {
  font-size: 1.2rem;
  color: white;
  background: transparent;
  border: none;
}

.sidebar-header .close-btn.p-button:not(:disabled):hover {
  background: none;
  color: var(--white);
}

.sidebar .card.relocation {
  margin-bottom: 0px;
  border: none;
}

.sidebar .card.sidebardetails {
  margin-bottom: 0px;
  border: none;
}

.sidebar .catefilter {
  padding: 8px 18px;
}

/* 
.sidebar .p-treeselect .p-treeselect-label {
  padding: 0px;
} */

.sidebar .p-fileupload .p-fileupload-content {
  padding: 8px 18px;
}

.sidebar .card.resume {
  margin-bottom: 0px;
}

.sidebar .form-control {
  padding: 8px 18px;
  border: 1px solid var(--border-color);
}

.custombtns .p-button.p-fileupload-choose {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
}

.sidebar .p-button {
  padding: 7px 18px;
  font-size: 15px;
}

.sidebar .editicon {
  display: flex;
  justify-content: end;
  color: var(--light-blue);
}

/* padding: 7px 18px;
  font-size: 15px;
} */


/* 12-2-24 */
#sidebar-menu ul li ul.sub-menu li.mm-active a {
  color: var(--txt-color2);
  font-weight: 600;
}

.sidebar .p-dropdown.activejobdrop {
  padding: 0px;
}

.sidebar .p-dropdown.activejobdrop {
  padding: 0px;
}

.sidebar .p-dropdown.activejobdrop:not(.p-disabled):hover {
  /* border-color: #6366f1; */
  background-image: none !important;
}

.sidebar .p-button.p-inputnumber-button-up {
  padding: 0px;
}

.sidebar .p-button.p-inputnumber-button-down {
  padding: 0px;
}

/* .sidebardetails .heading{} */

.sidebar .p-button.p-inputnumber-button-up {
  padding: 0px;
}

.sidebar .p-button.p-inputnumber-button-down {
  padding: 0px;
}

.sidebardetails .heading {
  font-size: 20px;
  font-weight: 500;
}

.sidebar .btn-primary.p-button.aibtn {
  border: 1px solid var(--border-color);
  color: var(--black);
  background-color: transparent;
  padding: 7px 18px;
}

.sidebar .btn-primary.p-button.aibtn:not(:disabled):hover {
  background: none;
}

.p-component.minmaxsal {
  width: 100%;
}

.sidebar .p-dropdown .p-dropdown-label.p-placeholder {
  color: #4b5563;
}

.jobac.p-dropdown input::placeholder {
  color: #000;
}

.jobac.p-dropdown:not(.p-disabled):hover {
  background-image: none !important;
  color: #000 !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
}

.breadcrumb-card .p-dropdown .p-dropdown-label.p-placeholder:hover {
  color: #000;
}

.p-dropdown .p-dropdown-trigger .p-icon {
  width: 14px;
  height: 12px;
}

.p-tabview.p-component .p-icon {
  width: 14px;
  height: 12px;
  margin-bottom: 4px;
}

.p-datatable .p-column-header-content .p-icon {
  width: 14px;
  height: 12px;
  margin-bottom: 2px;
}

/* 3-12-2024 */
.btn-primary.outlinebtn {
  border: 1px solid var(--dark-blue);
  color: var(--black);
  background-color: transparent;
  padding: 7px 18px;
  font-size: 15px;
}

.howyearsbg {
  background: var(--gsbgcolor);
  padding: 16px 8px 16px 16px;
  border-radius: 10px;
}

.p-multiselect-label {
  padding: 8px 18px;
}

.p-multiselect .p-multiselect-trigger .p-icon {
  width: 14px;
  height: 12px;
}

.vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a {
  width: calc(228px + 70px);
}

.vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>ul {
  width: 228px;
}

.vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a {
  color: var(--txt-color2);
}

.vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover {
  color: var(--txt-color2);
}

/* .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {
  background-color: var(--bgactive-color);
  color: var(--bs-sidebar-dark-menu-item-hover-color);
} */
/* .activejobdrop */

/* laxmi */

.sidebar .aibtn {
  border: 1px solid var(--border-color);
  color: #4b5563;
  background-color: transparent;
  padding: 4px 18px;
  border-radius: 4px;
}

.aibtn {
  border: 1px solid var(--border-color);
  color: #4b5563;
  background-color: transparent;
  padding: 4px 18px;
  border-radius: 4px;
}



.p-component.minmaxsal {
  width: 100%;
}

.sidebar .p-dropdown .p-dropdown-label.p-placeholder {
  color: #4b5563;
}

.jobac.p-dropdown input::placeholder {
  color: #000;
}

.jobac.p-dropdown:not(.p-disabled):hover {
  background-image: none !important;
  color: #000 !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: none;
}

.breadcrumb-card .p-dropdown .p-dropdown-label.p-placeholder:hover {
  color: #000;
}

.p-dropdown .p-dropdown-trigger .p-icon {
  width: 14px;
  height: 12px;
  color: #6b7280;
}

.p-tabview.p-component .p-icon {
  width: 14px;
  height: 12px;
  margin-bottom: 4px;
}

.p-datatable .p-column-header-content .p-icon {
  width: 14px;
  height: 12px;
  margin-bottom: 2px;
}

/* 3-12-2024 */
.btn-primary.p-button.outlinebtn {
  border: 1px solid var(--dark-blue);
  color: var(--black);
  background-color: transparent;
  padding: 6px 18px;
  font-size: 15px;
}

.howyearsbg {
  background: var(--gsbgcolor);
  padding: 16px 8px 16px 16px;
  border-radius: 10px;
}

.p-multiselect-label {
  padding: 8px 18px;
}

/* venkatlaxmi code end  */

/* 4-12-2024 */
.p-multiselect-trigger .p-icon {
  width: 14px;
  height: 12px;
}

.p-dropdown-label.p-inputtext::placeholder {
  color: #4b5563;
}

.p-datatable-wrapper {
  box-shadow: inset 0 -1px 0 0 rgba(100, 121, 143, 0.12);
  border: 1px solid #ececf1;
  border-radius: 6px;
}

.action-items .p-dropdown-items-wrapper {
  max-height: none !important;
}

.action-items.p-dropdown:not(.p-disabled):hover {
  /* border-color: #6366f1; */
  background-image: none !important;
  color: var(--white);
}

.address-popup .card.sidebardetails {
  border: none;
}

.address-popup .p-dropdown.activejobdrop:not(.p-disabled):hover {
  /* border-color: #6366f1; */
  background-image: none !important;
}

.address-popup .p-dropdown.activejobdrop {
  color: #4b5563;
  background: var(--white);
  border: 1px solid var(--border-color);
}

.address-popup .p-dropdown .p-dropdown-label.p-placeholder {
  color: #4b5563;
  font-weight: normal;
}

.p-dialog .p-dialog-header .p-dialog-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 0px;
}

.btn-primary.p-button.cancelbtn {
  border: 1px solid #f44336;
  color: #f44336;
  background-color: transparent;
  padding: 7px 18px;
  font-size: 15px;
}

.btn-primary.cancelbtn.p-button:not(:disabled):hover {
  background: none;
}

/* 9-12-24-laxmi */


.sidebar .editicon {
  display: flex;
  justify-content: end;
  color: #4b5563;
}

.sidebar .editicon:hover {
  display: flex;
  justify-content: end;
  color: var(--light-blue);
}

/* 12-12-24  view form*/

.view-form-sidebar .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  padding: 7px 18px;
  margin-right: 0px;
  border: none;
}

.view-form-sidebar .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {
  color: var(--white);
  font-weight: 500;
}

.view-form-sidebar .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  color: #4b5563;
  padding: 6px 18px;
  margin-right: 0px;
  border: 1px solid #6b7280;
  border-radius: 4px;
}

.view-form-sidebar .p-tabview .p-tabview-nav li .p-tabview-title {
  color: #4b5563;
}

.view-form-sidebar .p-treeselect .p-treeselect-label {
  padding: 0px;
}

.view-form-sidebar .p-dropdown {
  background: transparent;
  border: 1px solid var(--border-color);
}

.view-form-sidebar .p-dropdown:not(.p-disabled):hover {
  background-image: none !important;
  border: 1px solid var(--border-color);
  color: #d1d5db !important;
}

.view-form-sidebar .p-dropdown .p-dropdown-label.p-placeholder:hover {
  color: #4b5563 !important;
}

.view-form-sidebar .p-dropdown .p-dropdown-label.p-placeholder {
  color: #4b5563
}

.view-form .heading {
  font-size: 20px;
  font-weight: 600;
}

.sidebar label {
  font-weight: 400;
  margin-bottom: 4px;
}

.view-form-sidebar.p-sidebar {
  width: 1200px;
}

.view-form-sidebar .p-tabview .p-tabview-nav {
  display: flex;
  justify-content: space-evenly;
  padding: 0px 14px;
  margin-bottom: 0px;
  margin-top: 20px;
}

.view-form-sidebar .p-sidebar-header {
  display: none;
  padding: 0px;
}

.view-form-sidebar .sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--dark-blue);
  color: var(--white);
  padding: 10px 10px;
}

.view-form-sidebar .sidebar-header .close-btn {
  color: var(--white);
}

.view-form-sidebar .sidebar-header .close-btn.p-button:not(:disabled):hover {
  background: none;
  color: var(--white);
}

.view-form-sidebar .sidebarbtn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none;
  font-size: 15px;
}

label {
  color: #212529;
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 15px;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.view-form-sidebar .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
  background-image: var(--light-blue-gradient-angle);
  border-color: #e5e7eb;
  color: var(--white);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  padding: 10px;
}

.view-form-sidebar .p-accordion .p-accordion-header .p-accordion-header-link {
  padding: 10px;
  border: 1px solid #e5e7eb;
  color: var(--white);
  background-image: var(--light-blue-gradient-angle);
  font-weight: 400;
  border-radius: 6px;
  transition: box-shadow 0.2s;
}

.view-form-sidebar .p-badge {
  background: none;
  font-size: 28px;
}

.view-form-sidebar .head {
  font-size: 20px;
}

.view-form-sidebar .head i {
  font-size: 20px;
}

.view-form-sidebar .sub-head {
  font-size: 20px;
}

.view-form-sidebar .doc-table .p-column-title {
  font-weight: 500;
}

.view-form-sidebar .doc-table .p-button.p-button-danger {
  background: none;
  color: #4b5563;
}

.view-form-sidebar .doc-table .p-button:not(:disabled):hover {
  color: #4b5563;
}

/* 13-12-2024  */
.btn-main {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border: none !important;
  padding: 7px 18px !important;
  font-size: 15px !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

.btn.btn-primary.cancel-outlinebtn {
  border: 1px solid #f44336;
  color: #f44336;
  background-color: transparent;
  padding: 7px 18px;
  font-size: 15px;
}

.btn.btn-primary.cancel-outlinebtn:hover {
  border: 1px solid #f44336;
  color: #f44336;
  background-color: transparent;
  background: transparent;
  padding: 7px 18px;
  font-size: 15px;
}

.p-column-title {
  font-weight: 500;
}

.trashbtn {
  background: none !important;
  color: #4b5563 !important;
  border: none !important;
}

/* .p-datatable .p-datatable-tbody>tr>td {
  padding: 10px 10px;
} */

.p-treetable .p-treetable-wrapper table thead {
  background-color: var(--backclr);
}

.noti-icon.support-icon i {
  font-size: 20px;
}

.btn.bell-icon .badge {
  position: absolute !important;
  top: 8px !important;
  left: 16px;
}

.btn.bell-icon i {
  font-size: 20px;
}

/* lavan-13-12-24 */
.header-pop {
  width: 38vw;
}

.advanced-head {
  background-color: #eaf1fb !important;
  border-radius: 5px;
}

.popoup-clr.bg-form.card {
  background-color: transparent !important;
  border-radius: 5px;
  border: 1px solid #eee;
  margin-bottom: 0px;
}

.header-pop .p-dialog-content {
  /* background-color: #f5f9fd !important; */
  /*padding-bottom: 0px !important;*/
  padding: 0px;
  overflow-x: hidden;
}

.header-pop .p-dialog .p-dialog-header {
  padding: 1rem 1.5rem;
}


.add-selectoption .p-dropdown {
  background: var(--white);
  border: 1px solid #d1d5db;
}

.add-selectoption .p-dropdown .p-dropdown-label.p-placeholder:hover {
  color: var(--black);
}

.addfield-pop {
  background: var(--blue-gradient-angle) !important;
  border: none;
  padding: 8px 18px;
  border-radius: 4px;
}

.add-selectoption .bg-form .p-inputtext {
  border: 1px solid transparent;
}

.add-selectoption .p-dialog .p-dialog-header {
  padding: 10px 20px !important;
}

.select-close {
  background-color: transparent !important;
  border: none !important;
  margin-right: 10px !important;
}

.headpop-main .p-dialog .p-dialog-header {
  padding: 10px 20px !important;
}

.p-dialog-header {
  background-color: var(--dark-blue) !important;
  color: var(--white);
  font-weight: 500 !important;

}

.advan-modal {
  padding-right: 0px;
}

.advan-modal .p-dropdown.p-dropdown-label.p-placeholder:hover {
  color: var(--black);
}

.p-dialog .p-dialog-header {
  padding: 10px 20px !important;
  border-bottom: 1px solid #eee;
}

.advance-sr2 {
  background-color: var(--dark-blue) !important;
}

.advance-sr2 h4 {
  background-color: transparent !important;
  color: var(--white);
  font-family: "Plus Jakarta Sans", sans-serif;
}

.search-option.p-dropdown {
  border: 1px solid #d1d5db !important;
}

.app-search span {
  font-size: 20px;
  right: 5px;
  top: 6px;
  background-color: transparent;
  border: none;
}

.popup-merge {
  font-size: 15px !important;
  margin-top: 15px !important;
  font-weight: 700 !important;
  text-align: center !important;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.head-bulk {
  font-size: 16px !important;
  font-weight: 700 !important;
}

.p-fileupload .p-fileupload-buttonbar {
  padding: 8px 18px !important;
}

/* .p-button.p-component.p-disabled{
  border-radius: 100%;
} */

.p-steps .p-steps-item.p-highlight .p-steps-number {

  /* border-radius: 0 100% 100% 0; */
  border-radius: 0 100% 100% 0;
}

/* .bulk-resume .p-steps .p-steps-item.p-highlight .p-steps-number{
} */


.radio-wid {
  display: flex;
  justify-content: space-between;
  min-width: 300px;
  width: 300px;
}

.bulkresume-page .form-select {
  min-width: 300px !important;
  width: 350px !important;
}

.pop-interview .p-dropdown {
  background-color: var(--white) !important;
}

.interview-popup .p-dropdown-label.p-inputtext {
  border: none !important;
}

.interview-popup .p-chips.p-chips-multiple-container.p-chips-token {
  padding: 2px 10px !important;
}

.p-inputtext.p-chips-multiple-container {
  width: 100% !important;
}

.p-dialog .p-dialog-content {
  background: var(--white);
  color: #4b5563;
  padding: 20px 30px;
}

a {
  font-size: 15px;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
  color: var(--white);
  /* border-color: transparent; */
  border: none;
  background: transparent;
}

.p-dialog .p-dialog-header .p-dialog-header-icon {
  color: var(--white);
  /* border-color: transparent; */
  border: none;
  background: transparent;
}


.css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 18px !important;
}

.css-19qnlrw-MuiFormLabel-root-MuiInputLabel-root {
  top: -6px !important;
}

.css-1tlcqt-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 0px 18px !important;
}

.css-1dune0f-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 18px !important;
}

.MuiFormControl-root.MuiTextField-root.css-1b1fjlj-MuiFormControl-root-MuiTextField-root {
  width: 100% !important;
  border-radius: 7px !important;
}

.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {
  border-radius: 7px !important;
}

.css-10o2lyd-MuiStack-root>.MuiTextField-root,
.css-10o2lyd-MuiStack-root>.MuiPickersTextField-root {
  min-width: 149px !important;
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 10px 18px !important;
}

.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
  top: -6px !important;
}

.css-ka7ti6-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 2px !important;
}


.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 9px 10px !important;
  height: 1.3em !important;
}


/* lavan on 24-12-2024 */



.editorpage {
  min-height: 200px !important;
  height: 320px !important;
}

.interview-popup .p-dialog-footer {
  padding: 15px 32px !important;
  border-top: 1px solid #eee;
}

.popup-header span {
  font-size: 14px;
}

.popup-header-bg {
  background-color: rgb(243 244 246) !important;
  /* padding: 10px 20px 10px 43px !important; */
  margin-bottom: 20px;
  padding: 20px 10px;
}


.interview-popup.p-dialog-content {
  padding: 0px !important;

}

.interview-popup .whole-pad {
  padding: 20px 30px !important;
}

.popup-header .hover-btn.p-button {
  background-color: transparent;
  border: none;
  color: var(--backclr) !important;
  padding: 8px 0px 5px 10px !important;
}

.popup-header span {
  color: var(--black);
}

.popup-header .hover-btn.p-button:hover {
  background: transparent !important;
  border: none;
}

.popup-header ul {
  padding-left: 0px !important;
  margin-bottom: 0px;
}

.icon-top-button {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-top-button .pi {
  margin-bottom: 5px;
}


.interview-popup .p-menu-list.p-reset {
  /* padding-left: 0px !important; */
  padding: 0px 30px 20px 30px !important;

}

.interview-popup .ql-editor {
  margin-top: 4px;
  border-top: 1px solid #ccc;
  border-radius: 4px;
}

.interview-popup .ql-toolbar.ql-snow {
  border-radius: 4px;
}

.interview-popup .form-insidepop {
  padding: 0px 30px 20px 30px !important;
}

.size-mail .p-inputtext {
  padding: 3px 6px !important;
}

/* .p-inputtext */

.interview-popup .p-chips .p-chips-multiple-container .p-chips-token {
  padding: 0px 10px !important;
}

.from-width.p-dropdown .p-dropdown-trigger {
  width: 1.8rem !important;
}

.from-width.p-inputtext {
  padding: 2px 8px !important;
}

.from-width .p-inputtext {
  padding: 2px 8px !important;

}

.label-input {
  border: 1px solid #ccc !important;
  padding: 1px !important;
  border-radius: 4px;

}

.label-input .p-dropdown-label .p-inputtext .p-placeholder {
  padding: 0px;
}

.preview-icon .p-dropdown-trigger {
  display: none;

}

.form-attachp-button .p-component .p-fileupload-choose .p-fileupload-choose-selected .p-focus svg {
  display: none !important;
}

/* .footer-align{
  margin: 20px 0px 0px 0px;
} */

.footer {
  padding: 0px calc(1.5rem / 2);
}

.paginator-custom {
  background-color: transparent;
}

.footer-back {
  background-color: var(--gblack);
  /* padding: 20px 0; */
  z-index: 1000;
}

.footer-back .p-picklist .p-picklist-list .p-picklist-item {
  padding: 0.2rem !important;
}

.footer-back ul {
  padding-left: 0px !important;
}

.footer-back .p-picklist .p-picklist-list {
  padding-left: 0px !important;
}

.footer-tabsec .p-button.p-component.p-button-icon-only {
  border-radius: 100% !important;
  margin-top: 2px;
}

.footer-back .p-picklist .p-picklist-header {
  font-weight: 500;
}

.footer-back .gear-picklist {
  border-right: 2px solid #e3e3e3;
  padding-right: 10px;
}

.footer-back .gear-picklist:hover {
  cursor: pointer;
}


.footer-tabsec .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  padding: 3px 10px !important;
}

.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 3px 10px !important;
}

.footer-tabsec .p-paginator .p-paginator-first {
  min-width: 2.2rem !important;
}

.footer-back .paginator-custom.pagination-border.p-paginator.p-component {
  padding: 0.5rem 0rem !important;
}

.footer-tabsec dl,
ol,
ul {
  margin-bottom: 0rem !important;
}

.footer-back .p-paginator .p-paginator-first,
.p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next,
.p-paginator .p-paginator-last {
  min-width: 2.2rem !important;

}


.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {
  border-left: 2px solid #e3e3e3;
  height: 25px;
  padding-left: 15px;
}

.footer-back .p-dropdown.p-component.p-inputwrapper.p-inputwrapper-filled:hover {
  color: var(--white) !important;
}

.footer-back .p-component:hover {
  color: var(--white);
}


.footericons span i {
  color: #00000078 !important;
}

.footericons span i:hover {
  color: #000000 !important;
  cursor: pointer;
}

.footer-back .p-unselectable-text span {
  color: #000000a3;
}


.new-email .p-dialog .p-dialog-content {
  background: var(--white);
  color: #4b5563;
  padding: 0px 0px !important;
}


/* lavan-24-12-24  ends*/


/* lavan-13-12-24  ends*/

/* 17-12 */

.p-dropdown.bgclr {
  background: transparent;
  border: 1px solid var(--border-color);
}

.p-dropdown.bgclr:not(.p-disabled):hover {
  background-image: none !important;
}

.bg-form .p-calendar-w-btn .p-inputtext {
  border-radius: 0px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.bg-form .p-calendar-w-btn {
  border-radius: 4px;
}

.p-checkbox.p-invalid>.p-checkbox-box {
  border: 1px solid var(--border-color);
}

.page-title-box .page-title {
  font-size: 22px;
  font-weight: 500;
  font-family: "Plus Jakarta Sans", sans-serif;
  color: var(--dark-blue);
}

.form-select {
  font-family: "Plus Jakarta Sans", sans-serif;
}

.form-select::placeholder {
  font-size: 15px;
}

.bg-form .empty-message-custom {
  padding: 10px 18px;
}

/* 18-12-24 */
.p-treeselect .p-treeselect-label {
  padding: 0px;
}

svg.p-icon {
  width: 18px;
  height: 16px;
}

.linkd-icon {
  color: #0077B5;
  font-size: 16px;
}

.facebook-icon {
  color: #1877F2;
  font-size: 17px;
}

.twitter-icon {
  color: #1DA1F2;
  font-size: 15px;
}

.indeed-icon {
  color: #164081;
  font-size: 14px;
}

.p-dropdown .p-dropdown-label {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card-title {
  font-size: 16px;
  margin-bottom: 8px;
}

.card {
  margin-bottom: 20px;
}

a {
  text-decoration: none !important;
  color: #000;
}

.login-page .login-head {
  font-size: 22px;
  font-weight: 700;
  color: var(--dark-blue);
  text-align: left;
}

.login-page .login-card.p-card .p-card-body {
  box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%);
}

.view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {
  display: flex;
  justify-content: start;
  padding: 0px 14px;
  margin-bottom: 0px;
  margin-top: 20px;
}

.view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {
  margin-right: 20px;
}

.view-form-sidebar .tabview-sett h6 {
  font-weight: 500;
  color: #212529;
}

.profilebtn .p-button.p-component {
  background: transparent;
  border: none;
  /* padding-top: 20px; */
  font-size: 20px;
}

.profilebtn .p-button.p-component .pi {
  font-size: 19px;
  color: var(--active-color);
}

.profilebtn .p-button.p-component:hover {
  color: var(--icon-color);
}

.p-datatable .p-datatable-thead>tr>th {
  border: 1px solid #e5e7eb;
  color: #374151;
  border-top: none;
  border-left: none;
}

.screening-que .p-datatable .p-datatable-tbody>tr>td {
  text-align: left;
  border: 1px solid #e5e7eb;
  border-width: 0 0 1px 0;
  padding: 8px 16px;
}

.screening-que .p-datatable .p-datatable-thead>tr>th {
  padding: 8px 18px;
}

/* .p-datatable .p-datatable-tbody > tr > td {
  border: 1px solid #e5e7eb;
}

.p-datatable .p-datatable-thead > tr > th {
  border: 1px solid #e5e7eb;
} */
.profile-menu.p-menu .p-submenu-header {
  padding: 0px;
}

.profile-menu ul {
  padding-left: 0px;
  margin-bottom: 0px;
}

.profile-menu .p-menuitem-text {
  color: var(--active-color);
}

body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a {
  color: #b4c9de;
}

/* .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover i{
  color:#b4c9de ;
} */
body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a i {
  color: #b4c9de;
}

/* body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {
  color: #b4c9de !important;
} */

.vertical-collpsed .vertical-menu #sidebar-menu ul li a i:hover {
  color: #b4c9de !important;
}

/* view form css */

.candet-head {
  font-size: 22px;
  text-align: center;
  padding-top: 40px;
}

.candidate-form .container-fluid {
  padding-right: 120px;
  padding-left: 120px;
}

.candidate-form .tabs {
  box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%);
  margin-top: 40px;
  padding: 20px 10px 0px 20px;
}

.p-fileupload .p-fileupload-content {
  border: 1px solid var(--border-color);
}

.p-fileupload .p-fileupload-buttonbar {
  border: 1px solid var(--border-color);
  border-bottom: none;
}

.candidate-form .p-tabview-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px !important;
}

.file-upload-input {
  border: 1px solid #ccc;
  border-radius: 6px;
}

.pre-txthead {
  font-size: 18px;
  font-weight: 500;
  color: #0e527d;
}

.pi.pi-folder:hover {
  cursor: pointer;

}

.pi.pi-trash:hover {
  cursor: pointer;

}

.footer.detailsformfooter {
  left: 0px;
  padding: 20px calc(1.5rem / 2);
}

.footer.detailsformfooter .container-fluid {
  padding-right: 120px;
  padding-left: 120px;
}

.footer.detailsformfooter p {
  font-weight: 500;
}

.details-dialog.p-dialog .p-dialog-content {
  background: #f8f9fa;
}

.details-dialog .idbtn {
  background: none;
  color: #000;
  padding: 4px;
  font-size: 14px;
}

.details-dialog .openbtn {
  background: #000000;
  color: var(--white);
  padding: 4px;
  font-size: 14px;
}

.details-dialog .skillbtn {
  background: var(--gblack);
  padding: 4px 8px;
  font-size: 12px;
  border: none;
  color: #212529;
}

.profile-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* Circular background */
  background-color: #3498db;
  /* Blue background */
  color: var(--white);
  /* White icon color */
  font-size: 1.5rem;
  /* Icon size */
  margin-bottom: 10px;
}

.fs13 {
  font-size: 13px;
}

.btn-primary.p-button.emailbtn {
  border: 1px solid #6b7280;
  color: var(--black);
  background-color: transparent;
  padding: 4px 14px;
  font-size: 14px;
}

.details-dialog.p-dialog.p-component strong {
  font-weight: 500;
}

.details-dialog.p-dialog.p-component .diaicon {
  color: #0e527d;
}

/* 6-01-2025 */
.actjobsum .page-title {
  color: var(--dark-blue);
}

.p-column-filter-overlay.p-component ul {
  padding-left: 0px;
}

.actjobsumtable .p-datatable .p-datatable-thead>tr>th {
  padding: 12px 12px 12px 16px;
}

.actjobsumtable .p-datatable .p-datatable-tbody>tr>td {
  padding: 12px 12px 12px 16px;
}

.actjobsumtable .p-column-filter-clear-button {
  display: none;
}

.actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column {
  background: var(--white);
}

.actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column.p-resizable-column {
  background: #f9fafb;
}

.actjobsumtable .p-datatable .p-column-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actjobsumtable .p-datatable .p-column-filter-menu-button {
  display: inline-flex;
  justify-content: end;
}

.csvbtn.p-button {
  color: var(--white);
  background: #06b6d4;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 42px;
  height: 42px;
}

.pdfbtn.p-button {
  color: var(--white);
  background: #f97316;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 42px;
  height: 42px;
}

.printbtn.p-button {
  color: var(--white);
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  border-radius: 50%;
  font-size: 16px;
  width: 42px;
  height: 42px;
}

.xlsbtn.p-button {
  color: var(--white);
  background: #22c55e;
  border: none;
  border-radius: 50%;
  font-size: 16px;
  width: 42px;
  height: 42px;
}

.xlsbtn.p-button.p-button-success:not(:disabled):hover {
  background: #16a34a;
  color: var(--white);
  border: none;
}

.csvbtn.p-button:not(:disabled):hover {
  background: #0891b2;
  color: var(--white);
  border: none;
}

.pdfbtn.p-button:not(:disabled):hover {
  background: #ea580c;
  color: var(--white);
  border: none;
}

/* lavan */

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  position: relative;
}

body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {
  content: attr(data-full-text);
  white-space: normal;
}

.p-cascadeselect-panel.p-cascadeselect-items {
  padding-left: 0px;
}

.p-inputtext:enabled:focus i {
  color: #000;
}

.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {
  padding: 0.5rem 0.5rem;
}

.p-cascadeselect .p-cascadeselect-label {
  padding: 7px 18px;
}

.linkjobs {
  background: var(--backclr);
  border: none;
}

.btn.btn-primary.btn-font {
  border: 1px solid var(--border-color);
  color: #4b5563;
  background-color: transparent;
  padding: 6px 18px;
  font-size: 15px;
  border-radius: 0px;
}

.btn.btn-primary.btn-font:hover {
  border: 1px solid var(--border-color);
  color: #4b5563;
  background-color: transparent;
  background: transparent;
  padding: 6px 18px;
  font-size: 15px;
  border-radius: 0px;
}

.importres-sec {
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
}

.pi-archive::before {
  content: "\\e926";
}

/* 20-1-2025 */

.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: transparent;
}

.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {
  color: var(--dark-blue);
}

.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight {
  border-bottom: 1px solid var(--dark-blue);
}

.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  color: var(--dark-blue);
  margin-right: 0px;
  border: none;
  border-radius: none;
}

.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li .p-tabview-nav-link span {
  color: #4b5563;
}

.view-form-sidebar .pipelinetabs span.p-badge {
  background: #06b6d4;
  font-size: 14px;
  color: var(--white) !important;
}

.resumedetails#resume-content .name {
  font-size: 21px;
}

.resumedetails#resume-content .role {
  font-size: 18px;
  font-weight: 400;
}

.resumedetails#resume-content .contact {
  font-weight: 500;
}

.resumehead .date {
  font-weight: 400;
}

.notes .editbtn {
  background: transparent;
  color: #ffc107;
  border: none;
  padding: 0px;
}

.notes .deletebtn {
  background: transparent;
  color: #dc3545;
  border: none;
  padding: 0px;
}

.notes .editbtn.p-button:not(:disabled):hover {
  background: transparent;
  color: #ffc107;
  border-color: none;
  padding: 0px;
}

.notes .deletebtn.p-button:not(:disabled):hover {
  background: transparent;
  color: #dc3545;
  border: none;
  padding: 0px;
}

.notes .p-card {
  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.disabled {
  pointer-events: none;
  color: gray;
  /* Optional: Indicate visually that it's disabled */
  cursor: not-allowed;
}

.footer-popup.p-dialog .p-picklist-list-wrapper {
  padding: 20px 0px;
}

.footer-popup.p-dialog .p-picklist-source-controls button {
  margin-bottom: 10px;
}

.footer-popup.p-dialog .p-picklist-buttons button {
  margin-bottom: 10px;
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: var(--white);
  border-radius: 4px;
}

.footer-popup.p-dialog .p-picklist .p-picklist-list .p-picklist-item.p-highlight {
  color: #0e527d;
  background: var(--gsbgcolor);
  font-weight: 500;
}

.footer-popup.p-dialog .p-picklist .p-picklist-list {
  padding: 0px 0px;
}

.footer-popup.p-dialog .p-picklist .p-picklist-list .p-picklist-item {
  padding: 0rem 0rem 0rem 0rem;
}

.footer-popup.p-dialog .p-picklist-item .flex.flex-column.gap-2 {
  gap: 0rem !important;
}

.footer-popup.p-dialog .p-picklist .p-picklist-filter-container {
  padding: 10px;
}

.footer-popup.p-dialog .p-picklist .p-picklist-header {
  padding: 10px;
}

.footer-popup.p-dialog .p-picklist-item .flex.flex-column.gap-2 span {
  font-weight: 500;
}

.footer-popup.p-dialog .p-picklist .p-button {
  padding: 7px 16px;
}

.actjobsumtable .p-datatable .p-datatable-tbody>tr>td.p-frozen-column {
  font-weight: 500;
}

/* .actjobsumtable .p-datatable .p-frozen-column .p-column-filter .p-inputtext{
  border: 1px solid #4b5563;
} */
.interview-popup.p-dialog.p-component .bg-warning {
  border: 1px solid rgb(221, 221, 221) !important;
  border-radius: 4px !important;
  background: rgb(249, 249, 249) !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px !important;
}

.interview-popup.p-dialog.p-component .bg-warning button {
  background: transparent !important;
  color: #000 !important;
  padding: 0px !important;
}

.interview-popup.p-dialog.p-component .pi-times {
  font-size: 12px;
  color: #f44336;
}

.recruiter-dashboard .p-card {
  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--border-color);
}

.recruiter-dashboard .title {
  font-size: 18px;
  margin-bottom: 10px;
}

.recruiter-dashboard .smalltitle {
  font-size: 16px;
}

.recruiter-dashboard .smallhead {
  font-weight: 600;
  font-size: 22px;
}

.recruiter-dashboard .p-card .p-card-content {
  padding: 0.5rem 0;
}

/* .recruiter-dashboard .actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column.p-resizable-column {
  background: #e3f1ff;
} */

.success-txt {
  color: #28A745;
}

.danger-txt {
  color: #DC3545;
}

.recruiter-dashboard canvas {
  height: 375px !important;
}

.manager-dash .p-dropdown.bgclr {
  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.print-actitems {
  display: flex;
  justify-content: end;
}

.canprint-actitems {
  display: flex;
  justify-content: end;
}

.p-treeselect.p-component svg.p-icon {
  width: 14px;
  height: 12px;
}

.action-items a {
  color: #000 !important;
}

.p-cascadeselect-trigger svg.p-icon {
  width: 14px;
  height: 12px;
}

.sett-popup .p-tabview .p-tabview-panels {
  padding: 0px;
  padding-bottom: 10px;
}

.genraltxt {
  font-weight: 500;
}

.mandashtable .actjobsumtable .p-datatable {
  max-height: 400px;
  overflow-y: auto;
}

#sidebar-menu ul.metismenu li:hover {
  background: var(--backclr);
}

#sidebar-menu ul li ul.sub-menu li:hover {
  background: var(--backclr);
  font-weight: 400;
}

#sidebar-menu ul li ul.sub-menu li:hover a {
  background: var(--backclr);
  font-weight: 400;
}

/* Change tooltip background color and text color */
.p-tooltip {
  color: #fff;
}


/* #sidebar-menu ul li ul.sub-menu li.mm-active a */
/* body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a{
  overflow: visible;
} */

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {
  color: #000 !important;
  background: #e6f5ff !important;
}

.allact-tabs .import-res-btn.mainbtn {
  background: var(--white);
  color: #4b5563;
  border: 1px solid #d1d5db;
}

/* 4-2-2025 */

.clr-icons2 {
  display: none;
}

.clr-icons1 {
  display: block;
  float: right;
}

.clr-icons {
  float: right;
}

/* .addcan-ac{
  margin-right: 18px;
} */
.icons-ac {
  margin-right: 8px;
  margin-left: 8px;
}

.ac-items {
  background: var(--bs-header-bg);
  border-radius: 4px;
  padding: 10px 0px;
}

.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {
  padding: 7px 18px;
}

.clr-icons .icons-btn {
  background: #fff;
  color: #4b5563;
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 1px solid #d1d5db;
}

.clr-icons .icons-btn:hover {
  background: #4b5563 !important;
}

.icons-ac .icons-btn {
  background: #fff;
  color: #4b5563;
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 1px solid #d1d5db;
}

.icons-btn {
  background: #fff;
  color: #4b5563;
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 1px solid #d1d5db;
}

/* .btn.btn-primary.icons-btn{
  background: #fff;
  color: #4b5563;
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 1px solid #d1d5db;
} */

.clr-icons {
  float: right;
}

.p-cascadeselect .p-cascadeselect-label.p-placeholder {
  color: #4b5563;
}


.allact-tabs .p-cascadeselect .p-cascadeselect-label {
  padding: 6px 18px;
}

.allact-tabs .drop-ac .import-res-btn {
  background: var(--white) !important;
  color: #4b5563;
  border: 1px solid #d1d5db;
}

.allact-tabs .drop-ac .import-res-btn.btn:first-child:active {
  color: #4b5563;
}

.p-treeselect-label-container {
  padding: 7px 18px;
}

.p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {
  display: block;
   top: 0px !important;
  left: -125% !important;
}

.page-content.allact-tabs.manager-dash {
  margin-bottom: 50px;
}

.fw-500 {
  font-weight: 500;
}

.page-content.can-editform {
  margin-bottom: 100px !important;
}

.mt-40 {
  margin-top: 40px;
  padding-top: 100px;
}

.p-datatable .p-datatable-tbody>tr.p-highlight {
  background: #e6f5ff;
}

.p-checkbox.p-highlight .p-checkbox-box {
  border-color: #1c7cb9;
  background: #1c7cb9;
}

.allact-tabs .drop-ac .import-res-btn:not(.btn-check)+.btn:active {
  color: #4b5563;
}

.jobsall-editor .ql-editor table {
  table-layout: fixed;
}

.jobsall-editor .ql-editor table tr th {
  padding: 20px 0px !important;
}

.jobsall-editor {
  height: 45vh;
  margin-bottom: 25px;
}

.jobsall-editor .ql-editor td {
  border: 1px solid #d1d5db !important;
}

.jobsall-editor .ql-editor table {
  table-layout: auto;
  width: 100% !important;
}

.jobsall-editor .ql-editor table td {
  padding: 0.5rem 0.5rem !important;
}

.jobsall-editor .first-row {
  background: #000;
}

.addbtn {
  margin-top: 20px;
}

/* Custom CSS to remove space before the plus icon */
.addcus-cassel .p-cascadeselect-trigger {
  margin: 0 !important;
  padding: 10px;
  width: 35px;
  height: 35px;
}

.custom-plus-icon {
  margin-right: 0 !important;
  /* Remove margin on the right of the plus icon */
}

.addcus-cassel .p-cascadeselect-label.p-cascadeselect-label-empty {
  display: none;
}

.addcus-cassel.p-component {
  border-radius: 50%;
  /* border: 0.5px solid var(--active-color); */
  background: linear-gradient(90deg, #0e527d, #1a87cb);
  border: none;
}

.addbtn .p-cascadeselect-trigger svg.p-icon {
  color: #fff;
  font-weight: bolder;
}

.p-stepper-content .p-button {
  border: none;
  color: var(--white);
  padding: 7px 18px;
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
}

.dup-check .txt {
  margin-left: 20px;
}

.icons-btn .p-link {
  color: #4b5563;
}

.icons-btn .p-link:hover {
  color: #ffffff;
}

.kanban-view .p-card .p-card-content {
  padding: 0rem 0;
}

.kanban-view .p-card .p-card-body {
  padding: 1rem;
}

.kanban-view h3 {
  margin-right: 6px;
  font-size: 16px;
}

.kanban-view .p-card-content .font-medium {
  font-size: 16px;
}

.kanban-view .p-card-content .text-sm {
  font-size: 15px !important;
  margin-top: 2px;
}

.kanban-view .p-card-content .text-xs {
  font-size: 14px !important;
  margin-top: 2px;
}

.kanban-view .shadow-sm.border.p-card.p-component {
  margin-bottom: 10px;
}

.kanban-view .shadow-sm.border.p-card.p-component .p-card-body {
  padding: 10px 6px;
}

.kanban-view .p-card.p-component .p-card-content span {
  font-size: 13px;
}

.kanban-view .p-card.p-component .p-card-content .dates {
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
}

.kanban-view {
  margin-bottom: 60px;
}

.profilebtn .addcus-cassel.p-component {
  border: none;
  border-radius: 0;
  background: transparent;
  margin-top: 4px;
}

.profilebtn .addcus-cassel .p-cascadeselect-trigger {
  margin: 0 !important;
  padding: 0px;
  /* width: 14px;
  height: 37px; */
  color: #000;
}

.custom-profile-icon {
  font-size: 18px;
  margin-bottom: 8px;
}

.apply-btn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  /* color: #4b5563; */
  color: #fff;
  border: none;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 400;
  font-size: 15px;
  border: 1px solid #d1d5db;
}

.custom-cascadeselect .p-cascadeselect-sublist-wrapper {
  left: -120%;
}

.addcus-cassel.custom-cascadeselect .custom-item.p-cascadeselect-sublist-wrapper {
  left: -120%;
}

.applyjob-form {
  margin-bottom: 120px;
}

.job-details {
  margin-bottom: 120px;
}

.apply-btn {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  /* color: #4b5563; */
  color: #fff;
  border: none !important;
  font-family: "Plus Jakarta Sans", sans-serif !important;
  font-weight: 400 !important;
  font-size: 15px !important;
}

.create-ajob {
  margin-bottom: 100px;
}

.reset-pass {
  font-size: 22px;
  font-weight: 500;
  color: var(--dark-blue);
  text-align: left;
}

.backhome-txt {
  font-size: 15px;
  color: var(--dark-blue);
}

.btn {
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

.btn-success {
  font-weight: 400;
}

.p-datatable-scrollable-header {
  border-bottom: 1px solid #ccc !important;
}

.p-datatable-scrollable-header th {
  border-right: 1px solid #ccc !important;
}

.form-select {
  font-size: 15px !important;
}

.p-tooltip .p-tooltip-text {
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
  background: #0e527d;
  padding-top: 4px;
  padding-bottom: 4px;
}

.apply-job {
  color: #6b7280 !important;
}

.preview-btn {
  border-radius: 4px;
}

.sizebtns .p-button.p-component.p-highlight {
  background-image: linear-gradient(90deg, #0e527d, #1a87cb);
  color: #fff;
}

.jobsallactive-table.p-datatable.p-component {
  margin-bottom: 70px;
}

.p-contextmenu.p-component ul {
  padding-left: 0px;
}

.allact-tabs .card1.recruiter-table {
  margin-bottom: 70px !important;
}

.allact-tabs .drop-ac .import-res-btn:active {
  color: #4b5563;
  background-color: var(--bs-btn-active-bg);
  border: none;
}

.p-contextmenu {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.p-contextmenu .p-submenu-list {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.p-menuitem.p-menuitem-active.p-highlight a:hover {
  background: #e6f5ff;
}

.form-select {
  border: 1px solid #d1d5db;
}

.document-btn.p-button.p-component {
  background: none;
  border: none;
  padding: 0px 0px;
}

.p-treetable-table .p-treetable-tbody td {
  padding: 3px 12px 3px 16px;
}

.p-cascadeselect:not(.p-disabled).p-focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #c7d2fe;
  border-color: #6366f1;
}

.p-cascadeselect:not(.p-disabled):hover {
  border-color: #e6f5ff;
}

.accordian-menu.footer-align.close-tabssection .p-tabview-nav {
  display: flex;
  align-items: center;
}

.emp-status .p-column-filter {
  min-width: 8rem !important;
}

.p-dropdown.screendrp.bgclr {
  background: var(--white);
}

.p-dropdown.screendrp.bgclr .p-inputtext {
  padding: 6px 18px;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 7px 18px;
}

ul {
  padding-left: 0rem !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #000000;
  background: #e6f5ff;
}

.paginator-custom .p-dropdown.p-inputwrapper:hover .p-dropdown-label {
  color: var(--white);
}

.paginator-custom .p-dropdown.p-inputwrapper:hover .p-dropdown-trigger .p-icon {
  color: var(--white);
}

.admin-dash .actjobsumtable .p-button {
  background: none;
  border: none;
  color: var(--black);
}


.preview_img {
  width: 130px;
  height: 130px;
  /* background: #dfdfdf; */
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  border: 2px solid white;
  object-fit: cover;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); */
  object-fit: cover;
  /* padding: 20px; */
}

.preview_img .main_img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-shadow: inset 0 0 5px 0 #222222;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  border-radius: 100px;
}
.preview_img img {
    width: 100%;
    height: 100%;
    display: block;
}

.imgHidden {
    display: none;
}

.imgUploadCss {
    display: block;
    font-size: 16px;
    font-weight: 400;
    padding: 10px 20px;
    margin-top: 16px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    position: absolute;
    left: 150px;
    bottom: 80%;
    overflow: hidden;
    cursor: pointer;
}


.p-treeselect-items-wrapper {

  max-height: 250px !important;
}



.rolescheckboxcss {

  width: 15px;
  height: 20px;
}



.p-multiselect-panel {
  width: 100px !important;
}

#CandidateList_CardView .p-card-body {
  padding: 0.2rem 1rem;
}

#CandidateList_CardView .p-card-content {
  padding: 0.1rem 0;
}
#AllEmployees_TableView tbody tr td,
.CandidateListTableView tbody tr td {
  border-right: 1px solid #e3e4e6 !important;
}

.CandidateListTableView tbody tr td:last-child {
  border-right: 0px !important;
}
.CandidateListTableView thead tr th:nth-child(7) div {
  text-align: center;
}

/* .CandidateListTableView thead tr th:nth-child(7) div,
.CandidateListTableView tbody tr td:nth-child(7) {
  width: 100px !important;
} */

.CandidateListTableView tbody tr td:nth-child(1),
.CandidateListTableView tbody tr td:nth-child(6),
.CandidateListTableView tbody tr td:nth-child(7),
.CandidateListTableView tbody tr td:nth-child(8) {
  text-align: center !important;
}
.CandidateListTableView thead tr th div span {
  width: 100%;
  text-align: center !important;
}
#AllEmployees_TableView tbody tr td:nth-child(1),
#AllEmployees_TableView tbody tr td:nth-child(2),
#AllEmployees_TableView tbody tr td:nth-child(3),
#AllEmployees_TableView tbody tr td:nth-child(4),
#AllEmployees_TableView tbody tr td:nth-child(5),
#AllEmployees_TableView tbody tr td:nth-child(6){
    text-align: center !important;
}
#AllEmployees_TableView thead div span.p-column-title{
   width: 100%;
  text-align: center !important;
}

.org-shimmer {
  width: 100%;
  min-width: 100%;
  padding: 8px 0 16px;
  box-sizing: border-box;
}

.sidebar-shimmer {
  padding: 12px 10px 20px;
}

.sidebar-shimmer__item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  border-radius: 12px;
}

.sidebar-shimmer__icon,
.sidebar-shimmer__label {
  position: relative;
  overflow: hidden;
  background: #e7edf4;
}

.sidebar-shimmer__icon::after,
.sidebar-shimmer__label::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(231, 237, 244, 0) 0%, rgba(255, 255, 255, 0.92) 50%, rgba(231, 237, 244, 0) 100%);
  animation: orgShimmer 1.4s infinite;
}

.sidebar-shimmer__icon {
  width: 18px;
  min-width: 18px;
  height: 18px;
  border-radius: 6px;
}

.sidebar-shimmer__label {
  width: 100%;
  height: 14px;
  border-radius: 999px;
}

.org-shimmer__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.org-shimmer__actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.org-shimmer__table {
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.org-shimmer__row {
  display: grid;
  gap: 16px;
  padding: 18px 20px;
  border-top: 1px solid #eef2f7;
}

.org-shimmer__row--head {
  background: #f8fafc;
  border-top: 0;
}

.org-shimmer__line {
  position: relative;
  height: 14px;
  border-radius: 999px;
  background: #e7edf4;
  overflow: hidden;
}

.org-shimmer__line::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(231, 237, 244, 0) 0%, rgba(255, 255, 255, 0.9) 50%, rgba(231, 237, 244, 0) 100%);
  animation: orgShimmer 1.4s infinite;
}

.org-shimmer__line--title {
  height: 22px;
  max-width: 100%;
}

.org-shimmer__line--input {
  width: 170px;
  height: 38px;
  border-radius: 10px;
}

.org-shimmer__line--button {
  width: 150px;
  height: 38px;
  border-radius: 10px;
}

.org-shimmer__line--head {
  height: 12px;
  opacity: 0.95;
}

.org-shimmer__line--short {
  width: 72%;
}

@keyframes orgShimmer {
  100% {
    transform: translateX(100%);
  }
}

@media (max-width: 768px) {
  .org-shimmer__header {
    align-items: stretch;
  }

  .org-shimmer__actions {
    width: 100%;
  }

  .org-shimmer__line--input,
  .org-shimmer__line--button {
    width: 100%;
  }

  .org-shimmer__row {
    gap: 12px;
    padding: 16px;
  }
}

.recruiter-report-page {
  padding-bottom: 24px;
}

.recruiter-report-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 360px);
  gap: 20px;
  padding: 28px;
  margin-top: 68px;
  margin-bottom: 20px;
  border-radius: 24px;
  overflow: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 55%, #0ea5e9 100%);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);
}

.recruiter-report-hero-copy,
.recruiter-report-company-card {
  position: relative;
  z-index: 1;
}

.recruiter-report-hero-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(6px);
  opacity: 0.22;
}

.recruiter-report-hero-orb-one {
  width: 240px;
  height: 240px;
  top: -80px;
  right: 260px;
  background: #ffffff;
}

.recruiter-report-hero-orb-two {
  width: 200px;
  height: 200px;
  bottom: -70px;
  left: 32%;
  background: #67e8f9;
}

.recruiter-report-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #dbeafe;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.recruiter-report-title {
  color: #ffffff;
  font-size: 30px;
  font-weight: 550;
}

.recruiter-report-subtitle {
  max-width: 720px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 15px;
  line-height: 1.7;
}

.recruiter-report-hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
}

.recruiter-report-hero-pill {
  display: flex;
  flex-direction: column;
  min-width: 130px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  color: #dbeafe;
  font-size: 12px;
  font-weight: 600;
}

.recruiter-report-hero-pill-highlight {
  background: rgba(255, 255, 255, 0.16);
}

.recruiter-report-hero-pill-value {
  color: #ffffff;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.1;
}

.recruiter-report-company-card {
  /* align-self: stretch; */
  padding: 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
}

.recruiter-report-company-label {
  display: block;
  margin-bottom: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.recruiter-report-company-title {
  margin-bottom: 14px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
}

.recruiter-report-company-footnote {
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
}

.recruiter-report-filter-bar,
.recruiter-panel,
.recruiter-breakdown-panel {
  background: #ffffff;
  border: 1px solid #e6edf5;
  border-radius: 20px;
  box-shadow: 0 10px 35px rgba(15, 23, 42, 0.05);
}

.recruiter-report-filter-bar {
  display: grid;
  grid-template-columns: minmax(220px, 1.2fr) repeat(2, minmax(180px, 220px)) auto;
  gap: 16px;
  align-items: end;
  padding: 18px;
  margin-bottom: 20px;
}

.recruiter-report-filter-summary-label,
.recruiter-report-filter-label {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.recruiter-report-filter-summary-value {
  color: #0f172a;
  font-size: 20px;
  font-weight: 550;
}

.recruiter-report-filter-summary-meta {
  color: #64748b;
  font-size: 13px;
  margin-top: 4px;
}

.recruiter-report-filter-input {
  min-height: 42px;
  border-radius: 12px !important;
  border-color: #dbe4ee !important;
  box-shadow: none !important;
}

.recruiter-report-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.recruiter-report-filter-chip {
  padding: 10px 12px;
  border-radius: 999px;
  background: #e8f0ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-report-filter-chip-soft {
  background: #f1f5f9;
  color: #475569;
}

.recruiter-report-filter-reset {
  border: 0 !important;
  border-radius: 12px !important;
  background: #0f172a !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  padding: 10px 14px !important;
}

.recruiter-report-loading {
  padding: 8px 0 0;
}

.recruiter-report-error,
.recruiter-empty-state,
.recruiter-empty-table {
  padding: 18px;
  border-radius: 16px;
  background: #fff7ed;
  color: #9a3412;
  text-align: center;
  font-weight: 600;
}

.recruiter-report-summary-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.recruiter-summary-card {
  border-radius: 18px;
  padding: 4px 18px;
}

.recruiter-summary-card-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.recruiter-summary-value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
}

.recruiter-summary-label {
  margin-top: 6px;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
}

.recruiter-summary-accent {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  flex-shrink: 0;
}

.recruiter-panel {
  height: 100%;
  padding: 10px;
}

.recruiter-panel-full {
  min-height: 100%;
}

.recruiter-panel-header,
.recruiter-breakdown-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
}

.recruiter-panel-title {
  color: #0f172a;
  font-size: 20px;
  font-weight: 550;
}

.recruiter-panel-subtitle,
.recruiter-breakdown-subtitle {
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

.recruiter-panel-kicker,
.recruiter-breakdown-count {
  padding: 8px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.recruiter-snapshot-list {
  display: grid;
  gap: 14px;
}

.recruiter-snapshot-card {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr);
  gap: 14px;
  align-items: flex-start;
  padding: 16px;
  border: 1px solid #e6edf5;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.recruiter-rank-badge {
  min-width: 42px;
  padding: 10px 12px;
  border-radius: 14px;
  background: #0f172a;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  text-align: center;
}

.recruiter-avatar,
.recruiter-table-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 14px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 550;
  flex-shrink: 0;
}

.recruiter-snapshot-main {
  min-width: 0;
}

.recruiter-snapshot-name,
.recruiter-table-name {
  color: #0f172a;
  font-size: 15px;
  font-weight: 550;
}

.recruiter-snapshot-email,
.recruiter-table-subtext {
  color: #64748b;
  font-size: 13px;
  margin-top: 2px;
  word-break: break-word;
}

.recruiter-snapshot-meta {
  margin-top: 8px;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

.recruiter-progress-track,
.recruiter-table-bartrack {
  width: 100%;
  height: 8px;
  margin-top: 10px;
  border-radius: 999px;
  overflow: hidden;
  background: #e2e8f0;
}

.recruiter-progress-bar {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb 0%, #0f766e 100%);
}

.recruiter-snapshot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.recruiter-inline-chip,
.recruiter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-inline-chip-blue,
.recruiter-chip-blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.recruiter-inline-chip-pink,
.recruiter-chip-pink {
  background: #fce7f3;
  color: #be185d;
}

.recruiter-inline-chip-teal,
.recruiter-chip-teal {
  background: #ccfbf1;
  color: #0f766e;
}

.recruiter-inline-chip-violet,
.recruiter-chip-violet {
  background: #ede9fe;
  color: #6d28d9;
}

.recruiter-chip-warn {
  background: #ffedd5;
  color: #c2410c;
}

.recruiter-chip-green {
  background: #dcfce7;
  color: #15803d;
}

.recruiter-highlight-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.recruiter-highlight-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 150px;
  padding: 18px;
  border: 1px solid #e6edf5;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.recruiter-highlight-card strong {
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
}

.recruiter-highlight-card span:last-child {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

.recruiter-highlight-kicker {
  color: #2563eb;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.recruiter-breakdown-panel {
  padding: 20px;
}

.recruiter-breakdown-table-wrap {
  overflow-x: auto;
  border: 1px solid #e6edf5;
  border-radius: 18px;
}

.recruiter-table-person {
  /* border: 2px solid red; */
  justify-content: center;
}

.recruiter-breakdown-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.recruiter-breakdown-table thead th {
  position: sticky;
  top: 0;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e6edf5;
  border-right: 1px solid #edf2f7;
  color: #334155;
  font-size: 12px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  /* border: 2px solid red; */
}
.recruiter-breakdown-table thead th:nth-child(3),
.recruiter-breakdown-table thead th:nth-child(4) {
  /* border:1px solid red; */
  width: 200px;
  /* display: block; */
}


.recruiter-breakdown-table thead th:last-child,
.recruiter-breakdown-table tbody td:last-child {
  border-right: 0;
}

.recruiter-breakdown-table tbody tr.is-alt td {
  background: #fbfdff !important;
}

.recruiter-table-person {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

@media (max-width: 1200px) {
  .recruiter-report-summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 991px) {
  .recruiter-report-hero,
  .recruiter-report-filter-bar {
    grid-template-columns: 1fr;
  }

  .recruiter-highlight-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .recruiter-report-hero {
    padding: 20px;
  }

  .recruiter-report-title {
    font-size: 24px;
  }

  .recruiter-report-summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recruiter-snapshot-card {
    grid-template-columns: auto 1fr;
  }

  .recruiter-rank-badge {
    grid-column: 1 / -1;
    width: fit-content;
  }
}

@media (max-width: 575px) {
  .recruiter-report-summary-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,kEAAkE;EAClE,8CAA8C;EAC9C,gEAAgE;EAChE,+DAA+D;EAC/D;;oBAEkB;EAClB;;iCAE+B;EAC/B,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;;;;;EAME,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;AACH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,SAAS;EACT,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;;;GAGG;AACH;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yEAAyE;EACzE,SAAS;EACT,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;;AAEb;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,+DAA+D;EAC/D,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,0DAA0D;EAC1D,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0DAA0D;EAC1D,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;wCACwC;;AAExC;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,iEAAiE;EACjE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;;AAElB;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,4CAA4C;EAC5C,0DAA0D;EAC1D,0DAA0D;AAC5D;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,WAAW;;AAEb;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;;AAGA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;EACZ,iFAAiF;EACjF,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;AAGA;EACE,2BAA2B;EAC3B,uDAAuD;EACvD,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,mDAAmD;EACnD,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA,UAAU;;AAEV;EACE,yCAAyC;AAC3C;;AAEA;;KAEK;;AAEL;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;;AAGA;EACE,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,mBAAmB;;AAErB;;AAEA,UAAU;;;AAGV,WAAW;;AAEX;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA,WAAW;;AAEX,4BAA4B;;AAE5B,UAAU;;AAEV;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iFAAiF;EACjF,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;GAEG;;;AAGH,YAAY;AACZ;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;GAGG;AACH,mBAAmB;;AAEnB,UAAU;;AAEV;EACE,qCAAqC;EACrC,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;;AAE1B,cAAc;AACd;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;;;AAGlB;EACE,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,uBAAuB;;AAEvB;EACE,0DAA0D;EAC1D,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,2BAA2B;;AAE7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH;;EAEE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;GACG;;;AAGH;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;AACzB;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;;AAGA,wBAAwB;;;;AAIxB;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,uBAAuB;;AAEzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,kCAAkC;EAClC,sCAAsC;;AAExC;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;;AAEjB;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;;AAEpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;;;;EAIE,4BAA4B;;AAE9B;;;AAGA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,wBAAwB;EACxB,cAAc;EACd,2BAA2B;AAC7B;;;AAGA,wBAAwB;;;AAGxB,wBAAwB;;AAExB,UAAU;;AAEV;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;GAMG;AACH;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;AACH;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,eAAe;;AAEjB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,UAAU;;AAEV;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;EAC1D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,+CAA+C;EAC/C,6BAA6B;EAC7B,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,WAAW;AACb;;;AAGA,mDAAmD;AACnD;;GAEG;;AAEH;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;AACH;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;;;;;GAQG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;GACb,mBAAmB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ;iBACe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0DAA0D;EAC1D,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,uDAAuD;EACvD,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0DAA0D;EAC1D,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,8CAA8C;EAC9C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;;EAEE,4BAA4B;AAC9B;;;;AAIA;;EAEE,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;;;;EAIE,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;;;;;;IAMI,6BAA6B;AACjC;AACA;GACG,WAAW;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,yHAAyH;EACzH,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,wHAAwH;EACxH,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,SAAS;IACT,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0EAA0E;EAC1E,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gFAAgF;EAChF,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;EAEE,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;;;AAGA;;EAEE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --white: #fff;\n  --black: #000;\n  --primary-black: rgba(0, 0, 0, 0.12);\n  --secondary-black: #212529;\n  --primary-blue-color: #293b83;\n  --secondary-blue-color: #3e56bf;\n  --dark-blue: #0e527d;\n  --border-lines: #e1e6e9;\n  --light-blue: #1a87cb;\n  --very-dark-blue: #24397a;\n  --very-dark-elephant-gray: #8f7777;\n  --elephant-dark-grey: #aaa;\n  --light-eleph-light-grey: #e5f0ff;\n  --disabled-light-grey: #e9ecef;\n  --very-light-grey: #d1d1d1;\n  --v-grey-light: #eee;\n  --table-row-bg-light-grey: #fafafa;\n  --box-shadow-color: #8b8084;\n  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);\n  /* linear-gradient(90deg, #031978, #3e56bf)  */\n  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);\n  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);\n  --light-blue-gradient-angle: linear-gradient(90deg,\n      #46a4cf 8%,\n      #2f324f 86.9%);\n  --green-gradient: linear-gradient(73.1deg,\n      rgba(34, 126, 34, 1) 8%,\n      rgba(99, 162, 17, 1) 86.9%);\n  --roboto-font-family: \"Plus Jakarta Sans\", sans-serif;\n  /* Gmail theme */\n  --backclr: #e0e0ea;\n  --gblack: #f6f8fc;\n  --gsbgcolor: #eaf1fb;\n  --bgactive-color: #d3e3fd;\n  --active-color: #001d35;\n  --txt-color2: #393a3f;\n  --icon-color: #5f6368;\n  --background-color: #f8f9fa;\n  --border-color: #d1d5db;\n}\n\nbody {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n#page-topbar .logo-lg.barath-logo {\n  margin: 0 auto;\n}\n\n/* #page-topbar .logo-sm.favicon-logo{\n    margin-left: -10px;\n} */\n#page-topbar {\n  background: var(--gblack);\n}\n\n.vertical-menu {\n  background: var(--gblack);\n}\n\n#sidebar-menu ul li a {\n  color: var(--active-color);\n}\n\n#sidebar-menu ul li a:hover {\n  color: var(--active-color);\n}\n\n.mm-active>a {\n  color: var(--active-color);\n  background: var(--bgactive-color);\n}\n\n.mm-active>a i {\n  color: var(--active-color) !important;\n}\n\n#sidebar-menu ul li a {\n  font-size: 16px;\n}\n\n#sidebar-menu > ul > li > a {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 46px;\n  padding: 12px 42px 12px 20px;\n  line-height: 1.25;\n}\n\n#sidebar-menu ul li a i {\n  font-size: 18px;\n  color: var(--active-color);\n}\n\n#sidebar-menu > ul > li > a i {\n  flex: 0 0 24px;\n  min-width: 24px;\n  margin-right: 10px;\n  line-height: 1;\n}\n\n#sidebar-menu > ul > li > a span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#sidebar-menu .has-arrow::after {\n  position: absolute;\n  top: 50%;\n  right: 18px;\n  float: none;\n  margin: 0;\n  line-height: 1;\n  transform: translateY(-50%);\n}\n\n#sidebar-menu .mm-active > .has-arrow::after {\n  transform: translateY(-50%) rotate(-180deg);\n}\n\n#sidebar-menu ul li a i:hover {\n  color: var(--active-color) !important;\n}\n\n#sidebar-menu ul li ul.sub-menu li a {\n  color: var(--txt-color2);\n}\n\n#sidebar-menu ul li a:hover i {\n  color: var(--gblack);\n}\n\n/* #sidebar-menu ul li a i {\n  color: var(--bs-sidebar-dark-menu-item-active-color);\n} */\n\n.header-item {\n  color: var(--icon-color);\n}\n\n.header-item:hover {\n  color: var(--icon-color);\n}\n\n.noti-icon i {\n  /* color: var(--icon-color); */\n  color: var(--active-color);\n}\n\n.navbar-brand-box {\n  background: transparent;\n  text-align: left;\n}\n\n.noti-icon.slider-icon i {\n  font-size: 20px;\n  color: #444746;\n}\n\n.app-search .form-control {\n  background-color: var(--gsbgcolor);\n  height: 46px;\n}\n\n/* \n.navbar-brand-box .barath-logo,.favicon-logo {\n   \n} */\n.linear-output .mainbtn {\n  color: #000;\n  background-color: var(--backclr);\n}\n\n.linear-output .mainbtn:hover {\n  color: #000;\n  background-color: var(--blue-gradient-angle) !important;\n}\n\n.mainbtn {\n  background-color: var(--backclr);\n  border: 0;\n  /* box-shadow: 5px 5px 10px #8f7777; */\n  /* font-family: Mukta, sans-serif; */\n  font-size: 15px;\n  /* font-weight: 700; */\n  padding: 7px 18px;\n  /* text-transform: uppercase; */\n  border-radius: 4px;\n  /* color: #fff; */\n  margin-left: 4px;\n}\n\n.btn-primary {\n  background: var(--blue-gradient-right);\n  /*  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb); */\n  border: 0;\n  /* box-shadow: 5px 5px 10px #8f7777; */\n  /* font-family: Mukta, sans-serif; */\n  font-size: 15px;\n  /* font-weight: 700; */\n  padding: 7px 18px;\n  /* text-transform: uppercase; */\n  border-radius: 4px;\n  color: #fff;\n}\n\n.btn-primary:hover {\n  background: var(--blue-gradient-angle);\n  font-size: 15px;\n  color: var(--white);\n}\n\n.mainbtn:hover {\n  background-image: var(--blue-gradient-angle);\n  color: var(--white);\n}\n\n.right-btn .mainbtn {\n  background-color: var(--white);\n}\n\n.right-btn .mainbtn {\n  background-color: var(--backclr);\n  color: var(--black);\n}\n\n.right-btn .mainbtn:hover {\n  color: var(--white);\n}\n\n/* nav tabs */\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  /* border: solid #e5e7eb; */\n  /* border-width: 0 0 2px 0; */\n  /* border-color: transparent transparent #e5e7eb transparent; */\n  /* background: #ececf1 !important;  */\n  color: #6b7280;\n  padding: 1.25rem;\n  /* font-weight: 700; */\n  /* border-top-right-radius: 6px; */\n  /* border-top-left-radius: 6px; */\n  /* transition: box-shadow 0.2s; */\n  /* margin: 0 0 -2px 0; */\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {\n  /* outline: 0 none; */\n  /* outline-offset: 0; */\n  /* box-shadow: inset 0 0 0 0.2rem #c7d2fe; */\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border-radius: none;\n  color: var(--white);\n  font-size: var(--bs-btn-font-size);\n}\n\n.p-tabview .p-tabview-nav {\n  /* // background: #ececf1; */\n  border: 1px solid #e5e7eb;\n  border-width: 0 0 2px 0;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus-visible {\n  border: none;\n  box-shadow: none;\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb) !important;\n  border-radius: 0px;\n}\n\n.accordian-menu .p-tabview-panels {\n  display: none;\n}\n\n.p-tabview-title {\n  font-size: 15px;\n  font-weight: 400;\n  color: #000;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border-color: transparent !important;\n  color: var(--white);\n  padding: 7px 18px;\n  margin-right: 10px;\n  border-radius: 4px;\n  margin-bottom: 0px;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {\n  color: var(--white);\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 8px 18px;\n  margin-right: 10px;\n}\n\n/* // --bs-btn-padding-x: 0.75rem;\n  //     --bs-btn-padding-y: 0.375rem; */\n\n.p-tabview .p-tabview-nav {\n  border: none;\n  border-width: 0 0 2px 0;\n}\n\n.p-tabview .p-tabview-nav {\n  background-color: transparent !important;\n}\n\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: none;\n  background: none;\n}\n\n.p-tabview .p-tabview-nav .p-tabview-closable span.p-tabview-close-icon {\n  font-size: 0.3rem;\n}\n\n.p-component {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  /* font-feature-settings: var(--font-feature-settings, normal); */\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.action-items .p-dropdown span {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.p-tabview-nav {\n  padding-left: 0px;\n}\n\n/* nav tabs ends */\n\n.vertical-collpsed .navbar-brand-box {\n  width: 172px !important;\n}\n\n.navbar-brand-box {\n  width: 196px;\n}\n\n.btn-secondary:active,\n.btn-secondary:hover {\n  background-color: var(--backclr);\n}\n\n.allact-tabs .card1 {\n  background: none;\n  margin-bottom: 0px;\n}\n\n.allact-tabs .card-body1 {\n  padding-bottom: 0px;\n  padding-left: 0px;\n}\n\n.allact-tabs .nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  /* background-color: var(--bs-nav-pills-link-active-bg); */\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n}\n\n.allact-tabs .breadcrumb-card {\n  background: var(--bs-header-bg);\n  border-radius: 6px;\n}\n\n.allact-tabs .import-res-btn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-highlight {\n  color: #000;\n}\n\n.p-component * {\n  font-size: 15px;\n}\n\n.p-inputtext {\n  padding: 7px 18px;\n  border-radius: 4px;\n  /* line-height: 0px; */\n}\n\n.p-inputtext::placeholder {\n  color: #4b5563;\n}\n\n.p-inputtext:enabled:hover {\n  border-color: none;\n}\n\n.p-inputtext:enabled:focus {\n  box-shadow: none;\n  border-color: none !important;\n  color: #000;\n}\n\n.p-paginator .p-dropdown {\n  margin-left: 0.5rem;\n  height: auto;\n}\n\n.p-inputtext:enabled:hover {\n  border-color: none;\n}\n\n/* .p-dropdown-items {\n  padding: 0px !important;\n} */\n\n.footer-back {\n  background-color: var(--gblack);\n}\n\n.add-pad {\n  padding: 8px 18px;\n}\n\n.p-datatable .p-datatable-tbody>tr>td {\n  text-align: left;\n}\n\n.p-speeddial-button.p-button.p-button-icon-only {\n  width: auto;\n  height: auto;\n  padding: 8px 14px;\n  border-radius: 4px;\n  background-color: #e0e0ea;\n  border: none;\n  color: #000;\n\n}\n\n.p-button:not(:disabled):hover {\n  background: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n}\n\n.p-button:focus {\n  box-shadow: none\n}\n\n.p-speeddial-action {\n  width: 3rem;\n  height: 3rem;\n  background: #ececf1 !important;\n  color: #000000 !important;\n}\n\n.productdemo .p-button {\n  background: #e0e0ea;\n  border: none;\n  padding: 8px 18px;\n  font-size: 15px;\n  border-radius: 4px !important;\n  border: none;\n  color: #000;\n  font-weight: 400 !important;\n}\n\n.p-toolbar {\n  background: #ececf1 !important;\n  border: none !important;\n  padding: 0px;\n  border-radius: 0px;\n  gap: 0px;\n}\n\n.p-button-label {\n  font-weight: 400;\n}\n\n\n#sidebar-menu ul li ul.sub-menu {\n  background-color: var(--white) !important;\n}\n\n#sidebar-menu ul li ul.sub-menu li a {\n  padding: 9px 20px 9px 56px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n#sidebar-menu ul li a:hover i {\n  color: #000000;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n  background: transparent;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  text-decoration: none;\n}\n\n#sidebar-menu ul li a {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  text-decoration: none;\n}\n\n\n.p-dropdown {\n  /* background:var(--backclr); */\n  background: var(--backclr);\n  border: none;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 4px;\n  outline-color: transparent;\n}\n\n.p-dropdown::placeholder {\n  color: #000 !important;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {\n  color: #000000;\n  background: var(--white);\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {\n  color: #000000;\n  background: var(--backclr);\n}\n\n\n.p-dropdown:not(.p-disabled):hover {\n  /* border-color: #6366f1; */\n  background-image: var(--blue-gradient-angle) !important;\n  color: var(--white);\n}\n\n\n.p-dropdown .p-dropdown-trigger {\n  color: var(--black);\n}\n\n.p-dropdown:not(.p-disabled):hover .p-dropdown .p-dropdown-trigger:hover {\n  color: var(--white);\n}\n\n/* .p-datatable .p-datatable-thead>tr>th {\n  padding: 1rem 8px;\n} */\n\n.page-content {\n  padding: 69px calc(1.5rem / 2) 0px calc(1.5rem / 2);\n  background: var(--white);\n  /* margin-bottom: 100px; */\n}\n\n.icon-style {\n  position: relative;\n  z-index: 99;\n  top: 0px;\n  gap: 10px;\n  left: 38px;\n}\n\n/* Lavan */\n\n.fullform-bkclr {\n  background-color: var(--background-color);\n}\n\n/* .p-tabview .p-tabview-panels {\n    background-color: var(--background-color);\n  } */\n\n.fullform-head {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n\n.fullform .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: 1px solid #eee;\n}\n\n.fullform .p-tabview-panels {\n  padding-top: 0px;\n}\n\n.p-badge.p-badge-success {\n  background-color: #6365f12e;\n  color: #4b5563;\n  padding: 4px 8px;\n  font-weight: 500;\n  font-size: 14px;\n  border-radius: 30px;\n}\n\n.p-badge.p-badge-secondary {\n  background-color: #64748b;\n  color: var(--white);\n  padding: 2px 4px;\n}\n\n.p-button.p-button-info {\n  background-color: var(--backclr);\n  border: none;\n  color: #000;\n}\n\n.p-button.p-button-danger {\n  background-color: var(--backclr);\n  border: none;\n  color: #000;\n}\n\n.bg-ltclr {\n  background-color: #f9fafb;\n}\n\n/* .full-form{\n  background-color: #;\n} */\n\n.bg-form.card {\n  /* background-color: #eaf1fb75 !important; */\n  border-radius: 15px;\n  border: 1px solid var(--border-color);\n}\n\n.extra.bg-form {\n  background-color: #eaf1fb75;\n  border-radius: 15px;\n}\n\n.bg-form .p-inputtext {\n  background-color: var(--white);\n}\n\n.extra .bg-form .p-inputtext {\n  background-color: #eaf1fb75;\n}\n\n.bg-form .p-dropdown .p-dropdown-trigger {\n  background-color: var(--white);\n}\n\n\n.form-btn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n}\n\n.form-btn:hover {\n  /* background-color: var(); */\n  color: var(--white);\n}\n\n.drop-clr {\n  background-color: #f0f6fc;\n}\n\n.drop-clr:hover {\n  background-color: #f0f6fc !important;\n  color: var(--black) !important;\n  border: none;\n}\n\n.bg-form .p-dropdown:not(.p-disabled):hover {\n  /* border-color: #6366f1; */\n  background-image: none !important;\n  color: var(--black) !important;\n}\n\n.bg-form .p-dropdown .p-dropdown-label.p-placeholder {\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.bg-backclr {\n  background-color: #f0f6fc;\n}\n\n.bg-form .p-checkbox .p-checkbox-input {\n  border: 2px solid #e6e7e9 !important;\n}\n\n.bg-form .card-title {\n  font-weight: 500;\n}\n\n.bg-form h4 {\n  background-color: #eaf1fb;\n  padding: 10px 8px;\n  border-radius: 5px;\n}\n\n.bg-form .p-datepicker-trigger {\n  background-color: var(--backclr);\n  color: var(--black);\n  border: none;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.formDisable {\n  opacity: 0.4;\n  cursor: pointer;\n}\n\n.formEnable {\n  opacity: 1;\n}\n\n.dis-none {\n  display: none;\n}\n\n.dis-bloc {\n  display: block;\n}\n\n.p-button {\n  background-color: var(--backclr);\n  border: 1px solid var(--backclr);\n  color: var(--black);\n  \n}\n\n/* Lavan */\n\n\n/* naveen */\n\n.p-datatable .p-datatable-tbody>tr>td {\n  text-align: left;\n  border: 1px solid #e5e7eb;\n  border-width: 0 0 1px 0;\n  /* padding: 0px 6px; */\n}\n\n.p-datatable .p-datatable-tbody>tr>td {\n  text-align: start !important;\n}\n\n.p-speeddial-opened .p-speeddial-rotate {\n  transform: rotate(90deg);\n}\n\n.p-tabview-title {\n  line-height: 1.5;\n}\n\n\n\n/* naveen */\n\n/* venkatlaxmi code start  */\n\n/* laxmi */\n\n.p-sidebar-right .p-sidebar {\n  width: 30vw;\n  height: 100%;\n}\n\n.sidebar .p-inputtext {\n  width: 100%;\n}\n\n.sidebar .p-dropdown {\n  width: 100%;\n  background: transparent;\n  border: none;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n  border-radius: 4px;\n  border: 1px solid var(--border-color);\n  /* padding: 8px 18px; */\n}\n\n.sidebar label {\n  font-weight: 500;\n  font-weight: 400;\n}\n\n.sidebar .sidebarbtn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none;\n}\n\n.sidebar .btn-primary.p-button.outlinebtn {\n  border: 1px solid var(--dark-blue);\n  color: var(--black);\n  background-color: transparent;\n  padding: 7px 18px;\n  padding: 6px 18px;\n}\n\n.sidebar .btn-primary.p-button.outlinebtn:hover {\n  color: var(--white);\n}\n\n.sidebar .p-sidebar-header {\n  display: none;\n  padding: 0px;\n}\n\n.p-sidebar .p-sidebar-content {\n  padding: 0px;\n}\n\n.sidebar .sidebardetails {\n  padding: 30px 30px;\n}\n\n.sidebar .buttons {\n  margin-top: 30px;\n}\n\n.sidebar .outlinebtn.p-button:not(:disabled):hover {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none;\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: var(--dark-blue);\n  /* Background color */\n  color: white;\n  padding: 10px 10px;\n}\n\n.sidebar-header h3 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 400 !important;\n  /* Adjust font size as needed */\n}\n\n.sidebar-header .close-btn {\n  font-size: 1.2rem;\n  color: white;\n  background: transparent;\n  border: none;\n}\n\n.sidebar-header .close-btn.p-button:not(:disabled):hover {\n  background: none;\n  color: var(--white);\n}\n\n.sidebar .card.relocation {\n  margin-bottom: 0px;\n  border: none;\n}\n\n.sidebar .card.sidebardetails {\n  margin-bottom: 0px;\n  border: none;\n}\n\n.sidebar .catefilter {\n  padding: 8px 18px;\n}\n\n/* \n.sidebar .p-treeselect .p-treeselect-label {\n  padding: 0px;\n} */\n\n.sidebar .p-fileupload .p-fileupload-content {\n  padding: 8px 18px;\n}\n\n.sidebar .card.resume {\n  margin-bottom: 0px;\n}\n\n.sidebar .form-control {\n  padding: 8px 18px;\n  border: 1px solid var(--border-color);\n}\n\n.custombtns .p-button.p-fileupload-choose {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n}\n\n.sidebar .p-button {\n  padding: 7px 18px;\n  font-size: 15px;\n}\n\n.sidebar .editicon {\n  display: flex;\n  justify-content: end;\n  color: var(--light-blue);\n}\n\n/* padding: 7px 18px;\n  font-size: 15px;\n} */\n\n\n/* 12-2-24 */\n#sidebar-menu ul li ul.sub-menu li.mm-active a {\n  color: var(--txt-color2);\n  font-weight: 600;\n}\n\n.sidebar .p-dropdown.activejobdrop {\n  padding: 0px;\n}\n\n.sidebar .p-dropdown.activejobdrop {\n  padding: 0px;\n}\n\n.sidebar .p-dropdown.activejobdrop:not(.p-disabled):hover {\n  /* border-color: #6366f1; */\n  background-image: none !important;\n}\n\n.sidebar .p-button.p-inputnumber-button-up {\n  padding: 0px;\n}\n\n.sidebar .p-button.p-inputnumber-button-down {\n  padding: 0px;\n}\n\n/* .sidebardetails .heading{} */\n\n.sidebar .p-button.p-inputnumber-button-up {\n  padding: 0px;\n}\n\n.sidebar .p-button.p-inputnumber-button-down {\n  padding: 0px;\n}\n\n.sidebardetails .heading {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.sidebar .btn-primary.p-button.aibtn {\n  border: 1px solid var(--border-color);\n  color: var(--black);\n  background-color: transparent;\n  padding: 7px 18px;\n}\n\n.sidebar .btn-primary.p-button.aibtn:not(:disabled):hover {\n  background: none;\n}\n\n.p-component.minmaxsal {\n  width: 100%;\n}\n\n.sidebar .p-dropdown .p-dropdown-label.p-placeholder {\n  color: #4b5563;\n}\n\n.jobac.p-dropdown input::placeholder {\n  color: #000;\n}\n\n.jobac.p-dropdown:not(.p-disabled):hover {\n  background-image: none !important;\n  color: #000 !important;\n}\n\n.p-dropdown:not(.p-disabled).p-focus {\n  box-shadow: none;\n}\n\n.breadcrumb-card .p-dropdown .p-dropdown-label.p-placeholder:hover {\n  color: #000;\n}\n\n.p-dropdown .p-dropdown-trigger .p-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.p-tabview.p-component .p-icon {\n  width: 14px;\n  height: 12px;\n  margin-bottom: 4px;\n}\n\n.p-datatable .p-column-header-content .p-icon {\n  width: 14px;\n  height: 12px;\n  margin-bottom: 2px;\n}\n\n/* 3-12-2024 */\n.btn-primary.outlinebtn {\n  border: 1px solid var(--dark-blue);\n  color: var(--black);\n  background-color: transparent;\n  padding: 7px 18px;\n  font-size: 15px;\n}\n\n.howyearsbg {\n  background: var(--gsbgcolor);\n  padding: 16px 8px 16px 16px;\n  border-radius: 10px;\n}\n\n.p-multiselect-label {\n  padding: 8px 18px;\n}\n\n.p-multiselect .p-multiselect-trigger .p-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a {\n  width: calc(228px + 70px);\n}\n\n.vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>ul {\n  width: 228px;\n}\n\n.vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a {\n  color: var(--txt-color2);\n}\n\n.vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a:hover {\n  color: var(--txt-color2);\n}\n\n/* .vertical-collpsed .vertical-menu #sidebar-menu > ul > li:hover > a {\n  background-color: var(--bgactive-color);\n  color: var(--bs-sidebar-dark-menu-item-hover-color);\n} */\n/* .activejobdrop */\n\n/* laxmi */\n\n.sidebar .aibtn {\n  border: 1px solid var(--border-color);\n  color: #4b5563;\n  background-color: transparent;\n  padding: 4px 18px;\n  border-radius: 4px;\n}\n\n.aibtn {\n  border: 1px solid var(--border-color);\n  color: #4b5563;\n  background-color: transparent;\n  padding: 4px 18px;\n  border-radius: 4px;\n}\n\n\n\n.p-component.minmaxsal {\n  width: 100%;\n}\n\n.sidebar .p-dropdown .p-dropdown-label.p-placeholder {\n  color: #4b5563;\n}\n\n.jobac.p-dropdown input::placeholder {\n  color: #000;\n}\n\n.jobac.p-dropdown:not(.p-disabled):hover {\n  background-image: none !important;\n  color: #000 !important;\n}\n\n.p-dropdown:not(.p-disabled).p-focus {\n  box-shadow: none;\n}\n\n.breadcrumb-card .p-dropdown .p-dropdown-label.p-placeholder:hover {\n  color: #000;\n}\n\n.p-dropdown .p-dropdown-trigger .p-icon {\n  width: 14px;\n  height: 12px;\n  color: #6b7280;\n}\n\n.p-tabview.p-component .p-icon {\n  width: 14px;\n  height: 12px;\n  margin-bottom: 4px;\n}\n\n.p-datatable .p-column-header-content .p-icon {\n  width: 14px;\n  height: 12px;\n  margin-bottom: 2px;\n}\n\n/* 3-12-2024 */\n.btn-primary.p-button.outlinebtn {\n  border: 1px solid var(--dark-blue);\n  color: var(--black);\n  background-color: transparent;\n  padding: 6px 18px;\n  font-size: 15px;\n}\n\n.howyearsbg {\n  background: var(--gsbgcolor);\n  padding: 16px 8px 16px 16px;\n  border-radius: 10px;\n}\n\n.p-multiselect-label {\n  padding: 8px 18px;\n}\n\n/* venkatlaxmi code end  */\n\n/* 4-12-2024 */\n.p-multiselect-trigger .p-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.p-dropdown-label.p-inputtext::placeholder {\n  color: #4b5563;\n}\n\n.p-datatable-wrapper {\n  box-shadow: inset 0 -1px 0 0 rgba(100, 121, 143, 0.12);\n  border: 1px solid #ececf1;\n  border-radius: 6px;\n}\n\n.action-items .p-dropdown-items-wrapper {\n  max-height: none !important;\n}\n\n.action-items.p-dropdown:not(.p-disabled):hover {\n  /* border-color: #6366f1; */\n  background-image: none !important;\n  color: var(--white);\n}\n\n.address-popup .card.sidebardetails {\n  border: none;\n}\n\n.address-popup .p-dropdown.activejobdrop:not(.p-disabled):hover {\n  /* border-color: #6366f1; */\n  background-image: none !important;\n}\n\n.address-popup .p-dropdown.activejobdrop {\n  color: #4b5563;\n  background: var(--white);\n  border: 1px solid var(--border-color);\n}\n\n.address-popup .p-dropdown .p-dropdown-label.p-placeholder {\n  color: #4b5563;\n  font-weight: normal;\n}\n\n.p-dialog .p-dialog-header .p-dialog-title {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 0px;\n}\n\n.btn-primary.p-button.cancelbtn {\n  border: 1px solid #f44336;\n  color: #f44336;\n  background-color: transparent;\n  padding: 7px 18px;\n  font-size: 15px;\n}\n\n.btn-primary.cancelbtn.p-button:not(:disabled):hover {\n  background: none;\n}\n\n/* 9-12-24-laxmi */\n\n\n.sidebar .editicon {\n  display: flex;\n  justify-content: end;\n  color: #4b5563;\n}\n\n.sidebar .editicon:hover {\n  display: flex;\n  justify-content: end;\n  color: var(--light-blue);\n}\n\n/* 12-12-24  view form*/\n\n.view-form-sidebar .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  padding: 7px 18px;\n  margin-right: 0px;\n  border: none;\n}\n\n.view-form-sidebar .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {\n  color: var(--white);\n  font-weight: 500;\n}\n\n.view-form-sidebar .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  color: #4b5563;\n  padding: 6px 18px;\n  margin-right: 0px;\n  border: 1px solid #6b7280;\n  border-radius: 4px;\n}\n\n.view-form-sidebar .p-tabview .p-tabview-nav li .p-tabview-title {\n  color: #4b5563;\n}\n\n.view-form-sidebar .p-treeselect .p-treeselect-label {\n  padding: 0px;\n}\n\n.view-form-sidebar .p-dropdown {\n  background: transparent;\n  border: 1px solid var(--border-color);\n}\n\n.view-form-sidebar .p-dropdown:not(.p-disabled):hover {\n  background-image: none !important;\n  border: 1px solid var(--border-color);\n  color: #d1d5db !important;\n}\n\n.view-form-sidebar .p-dropdown .p-dropdown-label.p-placeholder:hover {\n  color: #4b5563 !important;\n}\n\n.view-form-sidebar .p-dropdown .p-dropdown-label.p-placeholder {\n  color: #4b5563\n}\n\n.view-form .heading {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.sidebar label {\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.view-form-sidebar.p-sidebar {\n  width: 1200px;\n}\n\n.view-form-sidebar .p-tabview .p-tabview-nav {\n  display: flex;\n  justify-content: space-evenly;\n  padding: 0px 14px;\n  margin-bottom: 0px;\n  margin-top: 20px;\n}\n\n.view-form-sidebar .p-sidebar-header {\n  display: none;\n  padding: 0px;\n}\n\n.view-form-sidebar .sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--dark-blue);\n  color: var(--white);\n  padding: 10px 10px;\n}\n\n.view-form-sidebar .sidebar-header .close-btn {\n  color: var(--white);\n}\n\n.view-form-sidebar .sidebar-header .close-btn.p-button:not(:disabled):hover {\n  background: none;\n  color: var(--white);\n}\n\n.view-form-sidebar .sidebarbtn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none;\n  font-size: 15px;\n}\n\nlabel {\n  color: #212529;\n  margin-bottom: 4px;\n  font-weight: 400;\n  font-size: 15px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.view-form-sidebar .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {\n  background-image: var(--light-blue-gradient-angle);\n  border-color: #e5e7eb;\n  color: var(--white);\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 10px;\n}\n\n.view-form-sidebar .p-accordion .p-accordion-header .p-accordion-header-link {\n  padding: 10px;\n  border: 1px solid #e5e7eb;\n  color: var(--white);\n  background-image: var(--light-blue-gradient-angle);\n  font-weight: 400;\n  border-radius: 6px;\n  transition: box-shadow 0.2s;\n}\n\n.view-form-sidebar .p-badge {\n  background: none;\n  font-size: 28px;\n}\n\n.view-form-sidebar .head {\n  font-size: 20px;\n}\n\n.view-form-sidebar .head i {\n  font-size: 20px;\n}\n\n.view-form-sidebar .sub-head {\n  font-size: 20px;\n}\n\n.view-form-sidebar .doc-table .p-column-title {\n  font-weight: 500;\n}\n\n.view-form-sidebar .doc-table .p-button.p-button-danger {\n  background: none;\n  color: #4b5563;\n}\n\n.view-form-sidebar .doc-table .p-button:not(:disabled):hover {\n  color: #4b5563;\n}\n\n/* 13-12-2024  */\n.btn-main {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border: none !important;\n  padding: 7px 18px !important;\n  font-size: 15px !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n.btn.btn-primary.cancel-outlinebtn {\n  border: 1px solid #f44336;\n  color: #f44336;\n  background-color: transparent;\n  padding: 7px 18px;\n  font-size: 15px;\n}\n\n.btn.btn-primary.cancel-outlinebtn:hover {\n  border: 1px solid #f44336;\n  color: #f44336;\n  background-color: transparent;\n  background: transparent;\n  padding: 7px 18px;\n  font-size: 15px;\n}\n\n.p-column-title {\n  font-weight: 500;\n}\n\n.trashbtn {\n  background: none !important;\n  color: #4b5563 !important;\n  border: none !important;\n}\n\n/* .p-datatable .p-datatable-tbody>tr>td {\n  padding: 10px 10px;\n} */\n\n.p-treetable .p-treetable-wrapper table thead {\n  background-color: var(--backclr);\n}\n\n.noti-icon.support-icon i {\n  font-size: 20px;\n}\n\n.btn.bell-icon .badge {\n  position: absolute !important;\n  top: 8px !important;\n  left: 16px;\n}\n\n.btn.bell-icon i {\n  font-size: 20px;\n}\n\n/* lavan-13-12-24 */\n.header-pop {\n  width: 38vw;\n}\n\n.advanced-head {\n  background-color: #eaf1fb !important;\n  border-radius: 5px;\n}\n\n.popoup-clr.bg-form.card {\n  background-color: transparent !important;\n  border-radius: 5px;\n  border: 1px solid #eee;\n  margin-bottom: 0px;\n}\n\n.header-pop .p-dialog-content {\n  /* background-color: #f5f9fd !important; */\n  /*padding-bottom: 0px !important;*/\n  padding: 0px;\n  overflow-x: hidden;\n}\n\n.header-pop .p-dialog .p-dialog-header {\n  padding: 1rem 1.5rem;\n}\n\n\n.add-selectoption .p-dropdown {\n  background: var(--white);\n  border: 1px solid #d1d5db;\n}\n\n.add-selectoption .p-dropdown .p-dropdown-label.p-placeholder:hover {\n  color: var(--black);\n}\n\n.addfield-pop {\n  background: var(--blue-gradient-angle) !important;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 4px;\n}\n\n.add-selectoption .bg-form .p-inputtext {\n  border: 1px solid transparent;\n}\n\n.add-selectoption .p-dialog .p-dialog-header {\n  padding: 10px 20px !important;\n}\n\n.select-close {\n  background-color: transparent !important;\n  border: none !important;\n  margin-right: 10px !important;\n}\n\n.headpop-main .p-dialog .p-dialog-header {\n  padding: 10px 20px !important;\n}\n\n.p-dialog-header {\n  background-color: var(--dark-blue) !important;\n  color: var(--white);\n  font-weight: 500 !important;\n\n}\n\n.advan-modal {\n  padding-right: 0px;\n}\n\n.advan-modal .p-dropdown.p-dropdown-label.p-placeholder:hover {\n  color: var(--black);\n}\n\n.p-dialog .p-dialog-header {\n  padding: 10px 20px !important;\n  border-bottom: 1px solid #eee;\n}\n\n.advance-sr2 {\n  background-color: var(--dark-blue) !important;\n}\n\n.advance-sr2 h4 {\n  background-color: transparent !important;\n  color: var(--white);\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.search-option.p-dropdown {\n  border: 1px solid #d1d5db !important;\n}\n\n.app-search span {\n  font-size: 20px;\n  right: 5px;\n  top: 6px;\n  background-color: transparent;\n  border: none;\n}\n\n.popup-merge {\n  font-size: 15px !important;\n  margin-top: 15px !important;\n  font-weight: 700 !important;\n  text-align: center !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.head-bulk {\n  font-size: 16px !important;\n  font-weight: 700 !important;\n}\n\n.p-fileupload .p-fileupload-buttonbar {\n  padding: 8px 18px !important;\n}\n\n/* .p-button.p-component.p-disabled{\n  border-radius: 100%;\n} */\n\n.p-steps .p-steps-item.p-highlight .p-steps-number {\n\n  /* border-radius: 0 100% 100% 0; */\n  border-radius: 0 100% 100% 0;\n}\n\n/* .bulk-resume .p-steps .p-steps-item.p-highlight .p-steps-number{\n} */\n\n\n.radio-wid {\n  display: flex;\n  justify-content: space-between;\n  min-width: 300px;\n  width: 300px;\n}\n\n.bulkresume-page .form-select {\n  min-width: 300px !important;\n  width: 350px !important;\n}\n\n.pop-interview .p-dropdown {\n  background-color: var(--white) !important;\n}\n\n.interview-popup .p-dropdown-label.p-inputtext {\n  border: none !important;\n}\n\n.interview-popup .p-chips.p-chips-multiple-container.p-chips-token {\n  padding: 2px 10px !important;\n}\n\n.p-inputtext.p-chips-multiple-container {\n  width: 100% !important;\n}\n\n.p-dialog .p-dialog-content {\n  background: var(--white);\n  color: #4b5563;\n  padding: 20px 30px;\n}\n\na {\n  font-size: 15px;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n  color: var(--white);\n  /* border-color: transparent; */\n  border: none;\n  background: transparent;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon {\n  color: var(--white);\n  /* border-color: transparent; */\n  border: none;\n  background: transparent;\n}\n\n\n.css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 18px !important;\n}\n\n.css-19qnlrw-MuiFormLabel-root-MuiInputLabel-root {\n  top: -6px !important;\n}\n\n.css-1tlcqt-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 0px 18px !important;\n}\n\n.css-1dune0f-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 18px !important;\n}\n\n.MuiFormControl-root.MuiTextField-root.css-1b1fjlj-MuiFormControl-root-MuiTextField-root {\n  width: 100% !important;\n  border-radius: 7px !important;\n}\n\n.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {\n  border-radius: 7px !important;\n}\n\n.css-10o2lyd-MuiStack-root>.MuiTextField-root,\n.css-10o2lyd-MuiStack-root>.MuiPickersTextField-root {\n  min-width: 149px !important;\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 10px 18px !important;\n}\n\n.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {\n  top: -6px !important;\n}\n\n.css-ka7ti6-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 2px !important;\n}\n\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 9px 10px !important;\n  height: 1.3em !important;\n}\n\n\n/* lavan on 24-12-2024 */\n\n\n\n.editorpage {\n  min-height: 200px !important;\n  height: 320px !important;\n}\n\n.interview-popup .p-dialog-footer {\n  padding: 15px 32px !important;\n  border-top: 1px solid #eee;\n}\n\n.popup-header span {\n  font-size: 14px;\n}\n\n.popup-header-bg {\n  background-color: rgb(243 244 246) !important;\n  /* padding: 10px 20px 10px 43px !important; */\n  margin-bottom: 20px;\n  padding: 20px 10px;\n}\n\n\n.interview-popup.p-dialog-content {\n  padding: 0px !important;\n\n}\n\n.interview-popup .whole-pad {\n  padding: 20px 30px !important;\n}\n\n.popup-header .hover-btn.p-button {\n  background-color: transparent;\n  border: none;\n  color: var(--backclr) !important;\n  padding: 8px 0px 5px 10px !important;\n}\n\n.popup-header span {\n  color: var(--black);\n}\n\n.popup-header .hover-btn.p-button:hover {\n  background: transparent !important;\n  border: none;\n}\n\n.popup-header ul {\n  padding-left: 0px !important;\n  margin-bottom: 0px;\n}\n\n.icon-top-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.icon-top-button .pi {\n  margin-bottom: 5px;\n}\n\n\n.interview-popup .p-menu-list.p-reset {\n  /* padding-left: 0px !important; */\n  padding: 0px 30px 20px 30px !important;\n\n}\n\n.interview-popup .ql-editor {\n  margin-top: 4px;\n  border-top: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.interview-popup .ql-toolbar.ql-snow {\n  border-radius: 4px;\n}\n\n.interview-popup .form-insidepop {\n  padding: 0px 30px 20px 30px !important;\n}\n\n.size-mail .p-inputtext {\n  padding: 3px 6px !important;\n}\n\n/* .p-inputtext */\n\n.interview-popup .p-chips .p-chips-multiple-container .p-chips-token {\n  padding: 0px 10px !important;\n}\n\n.from-width.p-dropdown .p-dropdown-trigger {\n  width: 1.8rem !important;\n}\n\n.from-width.p-inputtext {\n  padding: 2px 8px !important;\n}\n\n.from-width .p-inputtext {\n  padding: 2px 8px !important;\n\n}\n\n.label-input {\n  border: 1px solid #ccc !important;\n  padding: 1px !important;\n  border-radius: 4px;\n\n}\n\n.label-input .p-dropdown-label .p-inputtext .p-placeholder {\n  padding: 0px;\n}\n\n.preview-icon .p-dropdown-trigger {\n  display: none;\n\n}\n\n.form-attachp-button .p-component .p-fileupload-choose .p-fileupload-choose-selected .p-focus svg {\n  display: none !important;\n}\n\n/* .footer-align{\n  margin: 20px 0px 0px 0px;\n} */\n\n.footer {\n  padding: 0px calc(1.5rem / 2);\n}\n\n.paginator-custom {\n  background-color: transparent;\n}\n\n.footer-back {\n  background-color: var(--gblack);\n  /* padding: 20px 0; */\n  z-index: 1000;\n}\n\n.footer-back .p-picklist .p-picklist-list .p-picklist-item {\n  padding: 0.2rem !important;\n}\n\n.footer-back ul {\n  padding-left: 0px !important;\n}\n\n.footer-back .p-picklist .p-picklist-list {\n  padding-left: 0px !important;\n}\n\n.footer-tabsec .p-button.p-component.p-button-icon-only {\n  border-radius: 100% !important;\n  margin-top: 2px;\n}\n\n.footer-back .p-picklist .p-picklist-header {\n  font-weight: 500;\n}\n\n.footer-back .gear-picklist {\n  border-right: 2px solid #e3e3e3;\n  padding-right: 10px;\n}\n\n.footer-back .gear-picklist:hover {\n  cursor: pointer;\n}\n\n\n.footer-tabsec .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  padding: 3px 10px !important;\n}\n\n.footer-tabsec .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  padding: 3px 10px !important;\n}\n\n.footer-tabsec .p-paginator .p-paginator-first {\n  min-width: 2.2rem !important;\n}\n\n.footer-back .paginator-custom.pagination-border.p-paginator.p-component {\n  padding: 0.5rem 0rem !important;\n}\n\n.footer-tabsec dl,\nol,\nul {\n  margin-bottom: 0rem !important;\n}\n\n.footer-back .p-paginator .p-paginator-first,\n.p-paginator .p-paginator-prev,\n.p-paginator .p-paginator-next,\n.p-paginator .p-paginator-last {\n  min-width: 2.2rem !important;\n\n}\n\n\n.footer-back .p-paginator-first.p-paginator-element.p-link.p-disabled {\n  border-left: 2px solid #e3e3e3;\n  height: 25px;\n  padding-left: 15px;\n}\n\n.footer-back .p-dropdown.p-component.p-inputwrapper.p-inputwrapper-filled:hover {\n  color: var(--white) !important;\n}\n\n.footer-back .p-component:hover {\n  color: var(--white);\n}\n\n\n.footericons span i {\n  color: #00000078 !important;\n}\n\n.footericons span i:hover {\n  color: #000000 !important;\n  cursor: pointer;\n}\n\n.footer-back .p-unselectable-text span {\n  color: #000000a3;\n}\n\n\n.new-email .p-dialog .p-dialog-content {\n  background: var(--white);\n  color: #4b5563;\n  padding: 0px 0px !important;\n}\n\n\n/* lavan-24-12-24  ends*/\n\n\n/* lavan-13-12-24  ends*/\n\n/* 17-12 */\n\n.p-dropdown.bgclr {\n  background: transparent;\n  border: 1px solid var(--border-color);\n}\n\n.p-dropdown.bgclr:not(.p-disabled):hover {\n  background-image: none !important;\n}\n\n.bg-form .p-calendar-w-btn .p-inputtext {\n  border-radius: 0px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.bg-form .p-calendar-w-btn {\n  border-radius: 4px;\n}\n\n.p-checkbox.p-invalid>.p-checkbox-box {\n  border: 1px solid var(--border-color);\n}\n\n.page-title-box .page-title {\n  font-size: 22px;\n  font-weight: 500;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  color: var(--dark-blue);\n}\n\n.form-select {\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.form-select::placeholder {\n  font-size: 15px;\n}\n\n.bg-form .empty-message-custom {\n  padding: 10px 18px;\n}\n\n/* 18-12-24 */\n.p-treeselect .p-treeselect-label {\n  padding: 0px;\n}\n\nsvg.p-icon {\n  width: 18px;\n  height: 16px;\n}\n\n.linkd-icon {\n  color: #0077B5;\n  font-size: 16px;\n}\n\n.facebook-icon {\n  color: #1877F2;\n  font-size: 17px;\n}\n\n.twitter-icon {\n  color: #1DA1F2;\n  font-size: 15px;\n}\n\n.indeed-icon {\n  color: #164081;\n  font-size: 14px;\n}\n\n.p-dropdown .p-dropdown-label {\n  border-top-right-radius: 0px;\n  border-bottom-right-radius: 0px;\n}\n\n.card-title {\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.card {\n  margin-bottom: 20px;\n}\n\na {\n  text-decoration: none !important;\n  color: #000;\n}\n\n.login-page .login-head {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--dark-blue);\n  text-align: left;\n}\n\n.login-page .login-card.p-card .p-card-body {\n  box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%);\n}\n\n.view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav {\n  display: flex;\n  justify-content: start;\n  padding: 0px 14px;\n  margin-bottom: 0px;\n  margin-top: 20px;\n}\n\n.view-form-sidebar .p-tabview.tabview-sett .p-tabview-nav .p-unselectable-text {\n  margin-right: 20px;\n}\n\n.view-form-sidebar .tabview-sett h6 {\n  font-weight: 500;\n  color: #212529;\n}\n\n.profilebtn .p-button.p-component {\n  background: transparent;\n  border: none;\n  /* padding-top: 20px; */\n  font-size: 20px;\n}\n\n.profilebtn .p-button.p-component .pi {\n  font-size: 19px;\n  color: var(--active-color);\n}\n\n.profilebtn .p-button.p-component:hover {\n  color: var(--icon-color);\n}\n\n.p-datatable .p-datatable-thead>tr>th {\n  border: 1px solid #e5e7eb;\n  color: #374151;\n  border-top: none;\n  border-left: none;\n}\n\n.screening-que .p-datatable .p-datatable-tbody>tr>td {\n  text-align: left;\n  border: 1px solid #e5e7eb;\n  border-width: 0 0 1px 0;\n  padding: 8px 16px;\n}\n\n.screening-que .p-datatable .p-datatable-thead>tr>th {\n  padding: 8px 18px;\n}\n\n/* .p-datatable .p-datatable-tbody > tr > td {\n  border: 1px solid #e5e7eb;\n}\n\n.p-datatable .p-datatable-thead > tr > th {\n  border: 1px solid #e5e7eb;\n} */\n.profile-menu.p-menu .p-submenu-header {\n  padding: 0px;\n}\n\n.profile-menu ul {\n  padding-left: 0px;\n  margin-bottom: 0px;\n}\n\n.profile-menu .p-menuitem-text {\n  color: var(--active-color);\n}\n\nbody[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a {\n  color: #b4c9de;\n}\n\n/* .vertical-collpsed .vertical-menu #sidebar-menu > ul > li > a:hover i{\n  color:#b4c9de ;\n} */\nbody[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu>ul>li:hover>a i {\n  color: #b4c9de;\n}\n\n/* body[data-sidebar=dark].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active .active i {\n  color: #b4c9de !important;\n} */\n\n.vertical-collpsed .vertical-menu #sidebar-menu ul li a i:hover {\n  color: #b4c9de !important;\n}\n\n/* view form css */\n\n.candet-head {\n  font-size: 22px;\n  text-align: center;\n  padding-top: 40px;\n}\n\n.candidate-form .container-fluid {\n  padding-right: 120px;\n  padding-left: 120px;\n}\n\n.candidate-form .tabs {\n  box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%);\n  margin-top: 40px;\n  padding: 20px 10px 0px 20px;\n}\n\n.p-fileupload .p-fileupload-content {\n  border: 1px solid var(--border-color);\n}\n\n.p-fileupload .p-fileupload-buttonbar {\n  border: 1px solid var(--border-color);\n  border-bottom: none;\n}\n\n.candidate-form .p-tabview-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px !important;\n}\n\n.file-upload-input {\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.pre-txthead {\n  font-size: 18px;\n  font-weight: 500;\n  color: #0e527d;\n}\n\n.pi.pi-folder:hover {\n  cursor: pointer;\n\n}\n\n.pi.pi-trash:hover {\n  cursor: pointer;\n\n}\n\n.footer.detailsformfooter {\n  left: 0px;\n  padding: 20px calc(1.5rem / 2);\n}\n\n.footer.detailsformfooter .container-fluid {\n  padding-right: 120px;\n  padding-left: 120px;\n}\n\n.footer.detailsformfooter p {\n  font-weight: 500;\n}\n\n.details-dialog.p-dialog .p-dialog-content {\n  background: #f8f9fa;\n}\n\n.details-dialog .idbtn {\n  background: none;\n  color: #000;\n  padding: 4px;\n  font-size: 14px;\n}\n\n.details-dialog .openbtn {\n  background: #000000;\n  color: var(--white);\n  padding: 4px;\n  font-size: 14px;\n}\n\n.details-dialog .skillbtn {\n  background: var(--gblack);\n  padding: 4px 8px;\n  font-size: 12px;\n  border: none;\n  color: #212529;\n}\n\n.profile-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  /* Circular background */\n  background-color: #3498db;\n  /* Blue background */\n  color: var(--white);\n  /* White icon color */\n  font-size: 1.5rem;\n  /* Icon size */\n  margin-bottom: 10px;\n}\n\n.fs13 {\n  font-size: 13px;\n}\n\n.btn-primary.p-button.emailbtn {\n  border: 1px solid #6b7280;\n  color: var(--black);\n  background-color: transparent;\n  padding: 4px 14px;\n  font-size: 14px;\n}\n\n.details-dialog.p-dialog.p-component strong {\n  font-weight: 500;\n}\n\n.details-dialog.p-dialog.p-component .diaicon {\n  color: #0e527d;\n}\n\n/* 6-01-2025 */\n.actjobsum .page-title {\n  color: var(--dark-blue);\n}\n\n.p-column-filter-overlay.p-component ul {\n  padding-left: 0px;\n}\n\n.actjobsumtable .p-datatable .p-datatable-thead>tr>th {\n  padding: 12px 12px 12px 16px;\n}\n\n.actjobsumtable .p-datatable .p-datatable-tbody>tr>td {\n  padding: 12px 12px 12px 16px;\n}\n\n.actjobsumtable .p-column-filter-clear-button {\n  display: none;\n}\n\n.actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column {\n  background: var(--white);\n}\n\n.actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column.p-resizable-column {\n  background: #f9fafb;\n}\n\n.actjobsumtable .p-datatable .p-column-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.actjobsumtable .p-datatable .p-column-filter-menu-button {\n  display: inline-flex;\n  justify-content: end;\n}\n\n.csvbtn.p-button {\n  color: var(--white);\n  background: #06b6d4;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 42px;\n  height: 42px;\n}\n\n.pdfbtn.p-button {\n  color: var(--white);\n  background: #f97316;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 42px;\n  height: 42px;\n}\n\n.printbtn.p-button {\n  color: var(--white);\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  border-radius: 50%;\n  font-size: 16px;\n  width: 42px;\n  height: 42px;\n}\n\n.xlsbtn.p-button {\n  color: var(--white);\n  background: #22c55e;\n  border: none;\n  border-radius: 50%;\n  font-size: 16px;\n  width: 42px;\n  height: 42px;\n}\n\n.xlsbtn.p-button.p-button-success:not(:disabled):hover {\n  background: #16a34a;\n  color: var(--white);\n  border: none;\n}\n\n.csvbtn.p-button:not(:disabled):hover {\n  background: #0891b2;\n  color: var(--white);\n  border: none;\n}\n\n.pdfbtn.p-button:not(:disabled):hover {\n  background: #ea580c;\n  color: var(--white);\n  border: none;\n}\n\n/* lavan */\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  position: relative;\n}\n\nbody[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li a:hover {\n  content: attr(data-full-text);\n  white-space: normal;\n}\n\n.p-cascadeselect-panel.p-cascadeselect-items {\n  padding-left: 0px;\n}\n\n.p-inputtext:enabled:focus i {\n  color: #000;\n}\n\n.p-datatable.p-datatable-sm .p-datatable-thead>tr>th {\n  padding: 0.5rem 0.5rem;\n}\n\n.p-cascadeselect .p-cascadeselect-label {\n  padding: 7px 18px;\n}\n\n.linkjobs {\n  background: var(--backclr);\n  border: none;\n}\n\n.btn.btn-primary.btn-font {\n  border: 1px solid var(--border-color);\n  color: #4b5563;\n  background-color: transparent;\n  padding: 6px 18px;\n  font-size: 15px;\n  border-radius: 0px;\n}\n\n.btn.btn-primary.btn-font:hover {\n  border: 1px solid var(--border-color);\n  color: #4b5563;\n  background-color: transparent;\n  background: transparent;\n  padding: 6px 18px;\n  font-size: 15px;\n  border-radius: 0px;\n}\n\n.importres-sec {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: end;\n}\n\n.pi-archive::before {\n  content: \"\\e926\";\n}\n\n/* 20-1-2025 */\n\n.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  background: transparent;\n}\n\n.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span {\n  color: var(--dark-blue);\n}\n\n.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li.p-highlight {\n  border-bottom: 1px solid var(--dark-blue);\n}\n\n.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  color: var(--dark-blue);\n  margin-right: 0px;\n  border: none;\n  border-radius: none;\n}\n\n.view-form-sidebar .pipelinetabs .p-tabview .p-tabview-nav li .p-tabview-nav-link span {\n  color: #4b5563;\n}\n\n.view-form-sidebar .pipelinetabs span.p-badge {\n  background: #06b6d4;\n  font-size: 14px;\n  color: var(--white) !important;\n}\n\n.resumedetails#resume-content .name {\n  font-size: 21px;\n}\n\n.resumedetails#resume-content .role {\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.resumedetails#resume-content .contact {\n  font-weight: 500;\n}\n\n.resumehead .date {\n  font-weight: 400;\n}\n\n.notes .editbtn {\n  background: transparent;\n  color: #ffc107;\n  border: none;\n  padding: 0px;\n}\n\n.notes .deletebtn {\n  background: transparent;\n  color: #dc3545;\n  border: none;\n  padding: 0px;\n}\n\n.notes .editbtn.p-button:not(:disabled):hover {\n  background: transparent;\n  color: #ffc107;\n  border-color: none;\n  padding: 0px;\n}\n\n.notes .deletebtn.p-button:not(:disabled):hover {\n  background: transparent;\n  color: #dc3545;\n  border: none;\n  padding: 0px;\n}\n\n.notes .p-card {\n  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.disabled {\n  pointer-events: none;\n  color: gray;\n  /* Optional: Indicate visually that it's disabled */\n  cursor: not-allowed;\n}\n\n.footer-popup.p-dialog .p-picklist-list-wrapper {\n  padding: 20px 0px;\n}\n\n.footer-popup.p-dialog .p-picklist-source-controls button {\n  margin-bottom: 10px;\n}\n\n.footer-popup.p-dialog .p-picklist-buttons button {\n  margin-bottom: 10px;\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: var(--white);\n  border-radius: 4px;\n}\n\n.footer-popup.p-dialog .p-picklist .p-picklist-list .p-picklist-item.p-highlight {\n  color: #0e527d;\n  background: var(--gsbgcolor);\n  font-weight: 500;\n}\n\n.footer-popup.p-dialog .p-picklist .p-picklist-list {\n  padding: 0px 0px;\n}\n\n.footer-popup.p-dialog .p-picklist .p-picklist-list .p-picklist-item {\n  padding: 0rem 0rem 0rem 0rem;\n}\n\n.footer-popup.p-dialog .p-picklist-item .flex.flex-column.gap-2 {\n  gap: 0rem !important;\n}\n\n.footer-popup.p-dialog .p-picklist .p-picklist-filter-container {\n  padding: 10px;\n}\n\n.footer-popup.p-dialog .p-picklist .p-picklist-header {\n  padding: 10px;\n}\n\n.footer-popup.p-dialog .p-picklist-item .flex.flex-column.gap-2 span {\n  font-weight: 500;\n}\n\n.footer-popup.p-dialog .p-picklist .p-button {\n  padding: 7px 16px;\n}\n\n.actjobsumtable .p-datatable .p-datatable-tbody>tr>td.p-frozen-column {\n  font-weight: 500;\n}\n\n/* .actjobsumtable .p-datatable .p-frozen-column .p-column-filter .p-inputtext{\n  border: 1px solid #4b5563;\n} */\n.interview-popup.p-dialog.p-component .bg-warning {\n  border: 1px solid rgb(221, 221, 221) !important;\n  border-radius: 4px !important;\n  background: rgb(249, 249, 249) !important;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px !important;\n}\n\n.interview-popup.p-dialog.p-component .bg-warning button {\n  background: transparent !important;\n  color: #000 !important;\n  padding: 0px !important;\n}\n\n.interview-popup.p-dialog.p-component .pi-times {\n  font-size: 12px;\n  color: #f44336;\n}\n\n.recruiter-dashboard .p-card {\n  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--border-color);\n}\n\n.recruiter-dashboard .title {\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.recruiter-dashboard .smalltitle {\n  font-size: 16px;\n}\n\n.recruiter-dashboard .smallhead {\n  font-weight: 600;\n  font-size: 22px;\n}\n\n.recruiter-dashboard .p-card .p-card-content {\n  padding: 0.5rem 0;\n}\n\n/* .recruiter-dashboard .actjobsumtable .p-datatable .p-datatable-thead>tr>th.p-filter-column.p-resizable-column {\n  background: #e3f1ff;\n} */\n\n.success-txt {\n  color: #28A745;\n}\n\n.danger-txt {\n  color: #DC3545;\n}\n\n.recruiter-dashboard canvas {\n  height: 375px !important;\n}\n\n.manager-dash .p-dropdown.bgclr {\n  /* box-shadow: 0px 0px 50px 5px rgb(95 138 236 / 14%); */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.print-actitems {\n  display: flex;\n  justify-content: end;\n}\n\n.canprint-actitems {\n  display: flex;\n  justify-content: end;\n}\n\n.p-treeselect.p-component svg.p-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.action-items a {\n  color: #000 !important;\n}\n\n.p-cascadeselect-trigger svg.p-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.sett-popup .p-tabview .p-tabview-panels {\n  padding: 0px;\n  padding-bottom: 10px;\n}\n\n.genraltxt {\n  font-weight: 500;\n}\n\n.mandashtable .actjobsumtable .p-datatable {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n#sidebar-menu ul.metismenu li:hover {\n  background: var(--backclr);\n}\n\n#sidebar-menu ul li ul.sub-menu li:hover {\n  background: var(--backclr);\n  font-weight: 400;\n}\n\n#sidebar-menu ul li ul.sub-menu li:hover a {\n  background: var(--backclr);\n  font-weight: 400;\n}\n\n/* Change tooltip background color and text color */\n.p-tooltip {\n  color: #fff;\n}\n\n\n/* #sidebar-menu ul li ul.sub-menu li.mm-active a */\n/* body[data-sidebar=dark] #sidebar-menu ul li ul.sub-menu li.mm-active a{\n  overflow: visible;\n} */\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item.p-highlight {\n  color: #000 !important;\n  background: #e6f5ff !important;\n}\n\n.allact-tabs .import-res-btn.mainbtn {\n  background: var(--white);\n  color: #4b5563;\n  border: 1px solid #d1d5db;\n}\n\n/* 4-2-2025 */\n\n.clr-icons2 {\n  display: none;\n}\n\n.clr-icons1 {\n  display: block;\n  float: right;\n}\n\n.clr-icons {\n  float: right;\n}\n\n/* .addcan-ac{\n  margin-right: 18px;\n} */\n.icons-ac {\n  margin-right: 8px;\n  margin-left: 8px;\n}\n\n.ac-items {\n  background: var(--bs-header-bg);\n  border-radius: 4px;\n  padding: 10px 0px;\n}\n\n.p-cascadeselect-panel .p-cascadeselect-items .p-cascadeselect-item .p-cascadeselect-item-content {\n  padding: 7px 18px;\n}\n\n.clr-icons .icons-btn {\n  background: #fff;\n  color: #4b5563;\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  border: 1px solid #d1d5db;\n}\n\n.clr-icons .icons-btn:hover {\n  background: #4b5563 !important;\n}\n\n.icons-ac .icons-btn {\n  background: #fff;\n  color: #4b5563;\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  border: 1px solid #d1d5db;\n}\n\n.icons-btn {\n  background: #fff;\n  color: #4b5563;\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  border: 1px solid #d1d5db;\n}\n\n/* .btn.btn-primary.icons-btn{\n  background: #fff;\n  color: #4b5563;\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  border: 1px solid #d1d5db;\n} */\n\n.clr-icons {\n  float: right;\n}\n\n.p-cascadeselect .p-cascadeselect-label.p-placeholder {\n  color: #4b5563;\n}\n\n\n.allact-tabs .p-cascadeselect .p-cascadeselect-label {\n  padding: 6px 18px;\n}\n\n.allact-tabs .drop-ac .import-res-btn {\n  background: var(--white) !important;\n  color: #4b5563;\n  border: 1px solid #d1d5db;\n}\n\n.allact-tabs .drop-ac .import-res-btn.btn:first-child:active {\n  color: #4b5563;\n}\n\n.p-treeselect-label-container {\n  padding: 7px 18px;\n}\n\n.p-cascadeselect-item-active>.p-cascadeselect-sublist-wrapper {\n  display: block;\n   top: 0px !important;\n  left: -125% !important;\n}\n\n.page-content.allact-tabs.manager-dash {\n  margin-bottom: 50px;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.page-content.can-editform {\n  margin-bottom: 100px !important;\n}\n\n.mt-40 {\n  margin-top: 40px;\n  padding-top: 100px;\n}\n\n.p-datatable .p-datatable-tbody>tr.p-highlight {\n  background: #e6f5ff;\n}\n\n.p-checkbox.p-highlight .p-checkbox-box {\n  border-color: #1c7cb9;\n  background: #1c7cb9;\n}\n\n.allact-tabs .drop-ac .import-res-btn:not(.btn-check)+.btn:active {\n  color: #4b5563;\n}\n\n.jobsall-editor .ql-editor table {\n  table-layout: fixed;\n}\n\n.jobsall-editor .ql-editor table tr th {\n  padding: 20px 0px !important;\n}\n\n.jobsall-editor {\n  height: 45vh;\n  margin-bottom: 25px;\n}\n\n.jobsall-editor .ql-editor td {\n  border: 1px solid #d1d5db !important;\n}\n\n.jobsall-editor .ql-editor table {\n  table-layout: auto;\n  width: 100% !important;\n}\n\n.jobsall-editor .ql-editor table td {\n  padding: 0.5rem 0.5rem !important;\n}\n\n.jobsall-editor .first-row {\n  background: #000;\n}\n\n.addbtn {\n  margin-top: 20px;\n}\n\n/* Custom CSS to remove space before the plus icon */\n.addcus-cassel .p-cascadeselect-trigger {\n  margin: 0 !important;\n  padding: 10px;\n  width: 35px;\n  height: 35px;\n}\n\n.custom-plus-icon {\n  margin-right: 0 !important;\n  /* Remove margin on the right of the plus icon */\n}\n\n.addcus-cassel .p-cascadeselect-label.p-cascadeselect-label-empty {\n  display: none;\n}\n\n.addcus-cassel.p-component {\n  border-radius: 50%;\n  /* border: 0.5px solid var(--active-color); */\n  background: linear-gradient(90deg, #0e527d, #1a87cb);\n  border: none;\n}\n\n.addbtn .p-cascadeselect-trigger svg.p-icon {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.p-stepper-content .p-button {\n  border: none;\n  color: var(--white);\n  padding: 7px 18px;\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n}\n\n.dup-check .txt {\n  margin-left: 20px;\n}\n\n.icons-btn .p-link {\n  color: #4b5563;\n}\n\n.icons-btn .p-link:hover {\n  color: #ffffff;\n}\n\n.kanban-view .p-card .p-card-content {\n  padding: 0rem 0;\n}\n\n.kanban-view .p-card .p-card-body {\n  padding: 1rem;\n}\n\n.kanban-view h3 {\n  margin-right: 6px;\n  font-size: 16px;\n}\n\n.kanban-view .p-card-content .font-medium {\n  font-size: 16px;\n}\n\n.kanban-view .p-card-content .text-sm {\n  font-size: 15px !important;\n  margin-top: 2px;\n}\n\n.kanban-view .p-card-content .text-xs {\n  font-size: 14px !important;\n  margin-top: 2px;\n}\n\n.kanban-view .shadow-sm.border.p-card.p-component {\n  margin-bottom: 10px;\n}\n\n.kanban-view .shadow-sm.border.p-card.p-component .p-card-body {\n  padding: 10px 6px;\n}\n\n.kanban-view .p-card.p-component .p-card-content span {\n  font-size: 13px;\n}\n\n.kanban-view .p-card.p-component .p-card-content .dates {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2px;\n}\n\n.kanban-view {\n  margin-bottom: 60px;\n}\n\n.profilebtn .addcus-cassel.p-component {\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  margin-top: 4px;\n}\n\n.profilebtn .addcus-cassel .p-cascadeselect-trigger {\n  margin: 0 !important;\n  padding: 0px;\n  /* width: 14px;\n  height: 37px; */\n  color: #000;\n}\n\n.custom-profile-icon {\n  font-size: 18px;\n  margin-bottom: 8px;\n}\n\n.apply-btn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  /* color: #4b5563; */\n  color: #fff;\n  border: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 15px;\n  border: 1px solid #d1d5db;\n}\n\n.custom-cascadeselect .p-cascadeselect-sublist-wrapper {\n  left: -120%;\n}\n\n.addcus-cassel.custom-cascadeselect .custom-item.p-cascadeselect-sublist-wrapper {\n  left: -120%;\n}\n\n.applyjob-form {\n  margin-bottom: 120px;\n}\n\n.job-details {\n  margin-bottom: 120px;\n}\n\n.apply-btn {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  /* color: #4b5563; */\n  color: #fff;\n  border: none !important;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 15px !important;\n}\n\n.create-ajob {\n  margin-bottom: 100px;\n}\n\n.reset-pass {\n  font-size: 22px;\n  font-weight: 500;\n  color: var(--dark-blue);\n  text-align: left;\n}\n\n.backhome-txt {\n  font-size: 15px;\n  color: var(--dark-blue);\n}\n\n.btn {\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n.btn-success {\n  font-weight: 400;\n}\n\n.p-datatable-scrollable-header {\n  border-bottom: 1px solid #ccc !important;\n}\n\n.p-datatable-scrollable-header th {\n  border-right: 1px solid #ccc !important;\n}\n\n.form-select {\n  font-size: 15px !important;\n}\n\n.p-tooltip .p-tooltip-text {\n  max-width: 300px;\n  white-space: normal;\n  word-wrap: break-word;\n  background: #0e527d;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.apply-job {\n  color: #6b7280 !important;\n}\n\n.preview-btn {\n  border-radius: 4px;\n}\n\n.sizebtns .p-button.p-component.p-highlight {\n  background-image: linear-gradient(90deg, #0e527d, #1a87cb);\n  color: #fff;\n}\n\n.jobsallactive-table.p-datatable.p-component {\n  margin-bottom: 70px;\n}\n\n.p-contextmenu.p-component ul {\n  padding-left: 0px;\n}\n\n.allact-tabs .card1.recruiter-table {\n  margin-bottom: 70px !important;\n}\n\n.allact-tabs .drop-ac .import-res-btn:active {\n  color: #4b5563;\n  background-color: var(--bs-btn-active-bg);\n  border: none;\n}\n\n.p-contextmenu {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.p-contextmenu .p-submenu-list {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.p-menuitem.p-menuitem-active.p-highlight a:hover {\n  background: #e6f5ff;\n}\n\n.form-select {\n  border: 1px solid #d1d5db;\n}\n\n.document-btn.p-button.p-component {\n  background: none;\n  border: none;\n  padding: 0px 0px;\n}\n\n.p-treetable-table .p-treetable-tbody td {\n  padding: 3px 12px 3px 16px;\n}\n\n.p-cascadeselect:not(.p-disabled).p-focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #c7d2fe;\n  border-color: #6366f1;\n}\n\n.p-cascadeselect:not(.p-disabled):hover {\n  border-color: #e6f5ff;\n}\n\n.accordian-menu.footer-align.close-tabssection .p-tabview-nav {\n  display: flex;\n  align-items: center;\n}\n\n.emp-status .p-column-filter {\n  min-width: 8rem !important;\n}\n\n.p-dropdown.screendrp.bgclr {\n  background: var(--white);\n}\n\n.p-dropdown.screendrp.bgclr .p-inputtext {\n  padding: 6px 18px;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item {\n  padding: 7px 18px;\n}\n\nul {\n  padding-left: 0rem !important;\n}\n\n.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {\n  color: #000000;\n  background: #e6f5ff;\n}\n\n.paginator-custom .p-dropdown.p-inputwrapper:hover .p-dropdown-label {\n  color: var(--white);\n}\n\n.paginator-custom .p-dropdown.p-inputwrapper:hover .p-dropdown-trigger .p-icon {\n  color: var(--white);\n}\n\n.admin-dash .actjobsumtable .p-button {\n  background: none;\n  border: none;\n  color: var(--black);\n}\n\n\n.preview_img {\n  width: 130px;\n  height: 130px;\n  /* background: #dfdfdf; */\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  border: 2px solid white;\n  object-fit: cover;\n  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); */\n  object-fit: cover;\n  /* padding: 20px; */\n}\n\n.preview_img .main_img {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  box-shadow: inset 0 0 5px 0 #222222;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  /* display: flex; */\n  justify-content: center;\n  align-items: center;\n  border-radius: 100px;\n}\n.preview_img img {\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n\n.imgHidden {\n    display: none;\n}\n\n.imgUploadCss {\n    display: block;\n    font-size: 16px;\n    font-weight: 400;\n    padding: 10px 20px;\n    margin-top: 16px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    position: absolute;\n    left: 150px;\n    bottom: 80%;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n\n.p-treeselect-items-wrapper {\n\n  max-height: 250px !important;\n}\n\n\n\n.rolescheckboxcss {\n\n  width: 15px;\n  height: 20px;\n}\n\n\n\n.p-multiselect-panel {\n  width: 100px !important;\n}\n\n#CandidateList_CardView .p-card-body {\n  padding: 0.2rem 1rem;\n}\n\n#CandidateList_CardView .p-card-content {\n  padding: 0.1rem 0;\n}\n#AllEmployees_TableView tbody tr td,\n.CandidateListTableView tbody tr td {\n  border-right: 1px solid #e3e4e6 !important;\n}\n\n.CandidateListTableView tbody tr td:last-child {\n  border-right: 0px !important;\n}\n.CandidateListTableView thead tr th:nth-child(7) div {\n  text-align: center;\n}\n\n/* .CandidateListTableView thead tr th:nth-child(7) div,\n.CandidateListTableView tbody tr td:nth-child(7) {\n  width: 100px !important;\n} */\n\n.CandidateListTableView tbody tr td:nth-child(1),\n.CandidateListTableView tbody tr td:nth-child(6),\n.CandidateListTableView tbody tr td:nth-child(7),\n.CandidateListTableView tbody tr td:nth-child(8) {\n  text-align: center !important;\n}\n.CandidateListTableView thead tr th div span {\n  width: 100%;\n  text-align: center !important;\n}\n#AllEmployees_TableView tbody tr td:nth-child(1),\n#AllEmployees_TableView tbody tr td:nth-child(2),\n#AllEmployees_TableView tbody tr td:nth-child(3),\n#AllEmployees_TableView tbody tr td:nth-child(4),\n#AllEmployees_TableView tbody tr td:nth-child(5),\n#AllEmployees_TableView tbody tr td:nth-child(6){\n    text-align: center !important;\n}\n#AllEmployees_TableView thead div span.p-column-title{\n   width: 100%;\n  text-align: center !important;\n}\n\n.org-shimmer {\n  width: 100%;\n  min-width: 100%;\n  padding: 8px 0 16px;\n  box-sizing: border-box;\n}\n\n.sidebar-shimmer {\n  padding: 12px 10px 20px;\n}\n\n.sidebar-shimmer__item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  margin-bottom: 8px;\n  border-radius: 12px;\n}\n\n.sidebar-shimmer__icon,\n.sidebar-shimmer__label {\n  position: relative;\n  overflow: hidden;\n  background: #e7edf4;\n}\n\n.sidebar-shimmer__icon::after,\n.sidebar-shimmer__label::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, rgba(231, 237, 244, 0) 0%, rgba(255, 255, 255, 0.92) 50%, rgba(231, 237, 244, 0) 100%);\n  animation: orgShimmer 1.4s infinite;\n}\n\n.sidebar-shimmer__icon {\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  border-radius: 6px;\n}\n\n.sidebar-shimmer__label {\n  width: 100%;\n  height: 14px;\n  border-radius: 999px;\n}\n\n.org-shimmer__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.org-shimmer__actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.org-shimmer__table {\n  background: #ffffff;\n  border: 1px solid #e8edf3;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);\n}\n\n.org-shimmer__row {\n  display: grid;\n  gap: 16px;\n  padding: 18px 20px;\n  border-top: 1px solid #eef2f7;\n}\n\n.org-shimmer__row--head {\n  background: #f8fafc;\n  border-top: 0;\n}\n\n.org-shimmer__line {\n  position: relative;\n  height: 14px;\n  border-radius: 999px;\n  background: #e7edf4;\n  overflow: hidden;\n}\n\n.org-shimmer__line::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, rgba(231, 237, 244, 0) 0%, rgba(255, 255, 255, 0.9) 50%, rgba(231, 237, 244, 0) 100%);\n  animation: orgShimmer 1.4s infinite;\n}\n\n.org-shimmer__line--title {\n  height: 22px;\n  max-width: 100%;\n}\n\n.org-shimmer__line--input {\n  width: 170px;\n  height: 38px;\n  border-radius: 10px;\n}\n\n.org-shimmer__line--button {\n  width: 150px;\n  height: 38px;\n  border-radius: 10px;\n}\n\n.org-shimmer__line--head {\n  height: 12px;\n  opacity: 0.95;\n}\n\n.org-shimmer__line--short {\n  width: 72%;\n}\n\n@keyframes orgShimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@media (max-width: 768px) {\n  .org-shimmer__header {\n    align-items: stretch;\n  }\n\n  .org-shimmer__actions {\n    width: 100%;\n  }\n\n  .org-shimmer__line--input,\n  .org-shimmer__line--button {\n    width: 100%;\n  }\n\n  .org-shimmer__row {\n    gap: 12px;\n    padding: 16px;\n  }\n}\n\n.recruiter-report-page {\n  padding-bottom: 24px;\n}\n\n.recruiter-report-hero {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 360px);\n  gap: 20px;\n  padding: 28px;\n  margin-top: 68px;\n  margin-bottom: 20px;\n  border-radius: 24px;\n  overflow: hidden;\n  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 55%, #0ea5e9 100%);\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.16);\n}\n\n.recruiter-report-hero-copy,\n.recruiter-report-company-card {\n  position: relative;\n  z-index: 1;\n}\n\n.recruiter-report-hero-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(6px);\n  opacity: 0.22;\n}\n\n.recruiter-report-hero-orb-one {\n  width: 240px;\n  height: 240px;\n  top: -80px;\n  right: 260px;\n  background: #ffffff;\n}\n\n.recruiter-report-hero-orb-two {\n  width: 200px;\n  height: 200px;\n  bottom: -70px;\n  left: 32%;\n  background: #67e8f9;\n}\n\n.recruiter-report-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  margin-bottom: 14px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  color: #dbeafe;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.recruiter-report-title {\n  color: #ffffff;\n  font-size: 30px;\n  font-weight: 550;\n}\n\n.recruiter-report-subtitle {\n  max-width: 720px;\n  color: rgba(255, 255, 255, 0.86);\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.recruiter-report-hero-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.recruiter-report-hero-pill {\n  display: flex;\n  flex-direction: column;\n  min-width: 130px;\n  padding: 12px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  color: #dbeafe;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.recruiter-report-hero-pill-highlight {\n  background: rgba(255, 255, 255, 0.16);\n}\n\n.recruiter-report-hero-pill-value {\n  color: #ffffff;\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.recruiter-report-company-card {\n  /* align-self: stretch; */\n  padding: 20px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n}\n\n.recruiter-report-company-label {\n  display: block;\n  margin-bottom: 4px;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.recruiter-report-company-title {\n  margin-bottom: 14px;\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.recruiter-report-company-footnote {\n  margin-top: 6px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.recruiter-report-filter-bar,\n.recruiter-panel,\n.recruiter-breakdown-panel {\n  background: #ffffff;\n  border: 1px solid #e6edf5;\n  border-radius: 20px;\n  box-shadow: 0 10px 35px rgba(15, 23, 42, 0.05);\n}\n\n.recruiter-report-filter-bar {\n  display: grid;\n  grid-template-columns: minmax(220px, 1.2fr) repeat(2, minmax(180px, 220px)) auto;\n  gap: 16px;\n  align-items: end;\n  padding: 18px;\n  margin-bottom: 20px;\n}\n\n.recruiter-report-filter-summary-label,\n.recruiter-report-filter-label {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.recruiter-report-filter-summary-value {\n  color: #0f172a;\n  font-size: 20px;\n  font-weight: 550;\n}\n\n.recruiter-report-filter-summary-meta {\n  color: #64748b;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.recruiter-report-filter-input {\n  min-height: 42px;\n  border-radius: 12px !important;\n  border-color: #dbe4ee !important;\n  box-shadow: none !important;\n}\n\n.recruiter-report-filter-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.recruiter-report-filter-chip {\n  padding: 10px 12px;\n  border-radius: 999px;\n  background: #e8f0ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-report-filter-chip-soft {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.recruiter-report-filter-reset {\n  border: 0 !important;\n  border-radius: 12px !important;\n  background: #0f172a !important;\n  color: #ffffff !important;\n  font-weight: 700 !important;\n  padding: 10px 14px !important;\n}\n\n.recruiter-report-loading {\n  padding: 8px 0 0;\n}\n\n.recruiter-report-error,\n.recruiter-empty-state,\n.recruiter-empty-table {\n  padding: 18px;\n  border-radius: 16px;\n  background: #fff7ed;\n  color: #9a3412;\n  text-align: center;\n  font-weight: 600;\n}\n\n.recruiter-report-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.recruiter-summary-card {\n  border-radius: 18px;\n  padding: 4px 18px;\n}\n\n.recruiter-summary-card-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.recruiter-summary-value {\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.recruiter-summary-label {\n  margin-top: 6px;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.recruiter-summary-accent {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  flex-shrink: 0;\n}\n\n.recruiter-panel {\n  height: 100%;\n  padding: 10px;\n}\n\n.recruiter-panel-full {\n  min-height: 100%;\n}\n\n.recruiter-panel-header,\n.recruiter-breakdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.recruiter-panel-title {\n  color: #0f172a;\n  font-size: 20px;\n  font-weight: 550;\n}\n\n.recruiter-panel-subtitle,\n.recruiter-breakdown-subtitle {\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.recruiter-panel-kicker,\n.recruiter-breakdown-count {\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.recruiter-snapshot-list {\n  display: grid;\n  gap: 14px;\n}\n\n.recruiter-snapshot-card {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr);\n  gap: 14px;\n  align-items: flex-start;\n  padding: 16px;\n  border: 1px solid #e6edf5;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n}\n\n.recruiter-rank-badge {\n  min-width: 42px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: #0f172a;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.recruiter-avatar,\n.recruiter-table-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n  color: #1d4ed8;\n  font-size: 14px;\n  font-weight: 550;\n  flex-shrink: 0;\n}\n\n.recruiter-snapshot-main {\n  min-width: 0;\n}\n\n.recruiter-snapshot-name,\n.recruiter-table-name {\n  color: #0f172a;\n  font-size: 15px;\n  font-weight: 550;\n}\n\n.recruiter-snapshot-email,\n.recruiter-table-subtext {\n  color: #64748b;\n  font-size: 13px;\n  margin-top: 2px;\n  word-break: break-word;\n}\n\n.recruiter-snapshot-meta {\n  margin-top: 8px;\n  color: #475569;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.recruiter-progress-track,\n.recruiter-table-bartrack {\n  width: 100%;\n  height: 8px;\n  margin-top: 10px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #e2e8f0;\n}\n\n.recruiter-progress-bar {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #2563eb 0%, #0f766e 100%);\n}\n\n.recruiter-snapshot-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.recruiter-inline-chip,\n.recruiter-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 38px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-inline-chip-blue,\n.recruiter-chip-blue {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.recruiter-inline-chip-pink,\n.recruiter-chip-pink {\n  background: #fce7f3;\n  color: #be185d;\n}\n\n.recruiter-inline-chip-teal,\n.recruiter-chip-teal {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n.recruiter-inline-chip-violet,\n.recruiter-chip-violet {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n.recruiter-chip-warn {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.recruiter-chip-green {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.recruiter-highlight-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.recruiter-highlight-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 150px;\n  padding: 18px;\n  border: 1px solid #e6edf5;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n}\n\n.recruiter-highlight-card strong {\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.recruiter-highlight-card span:last-child {\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.recruiter-highlight-kicker {\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.recruiter-breakdown-panel {\n  padding: 20px;\n}\n\n.recruiter-breakdown-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e6edf5;\n  border-radius: 18px;\n}\n\n.recruiter-table-person {\n  /* border: 2px solid red; */\n  justify-content: center;\n}\n\n.recruiter-breakdown-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.recruiter-breakdown-table thead th {\n  position: sticky;\n  top: 0;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e6edf5;\n  border-right: 1px solid #edf2f7;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n  /* border: 2px solid red; */\n}\n.recruiter-breakdown-table thead th:nth-child(3),\n.recruiter-breakdown-table thead th:nth-child(4) {\n  /* border:1px solid red; */\n  width: 200px;\n  /* display: block; */\n}\n\n\n.recruiter-breakdown-table thead th:last-child,\n.recruiter-breakdown-table tbody td:last-child {\n  border-right: 0;\n}\n\n.recruiter-breakdown-table tbody tr.is-alt td {\n  background: #fbfdff !important;\n}\n\n.recruiter-table-person {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n@media (max-width: 1200px) {\n  .recruiter-report-summary-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 991px) {\n  .recruiter-report-hero,\n  .recruiter-report-filter-bar {\n    grid-template-columns: 1fr;\n  }\n\n  .recruiter-highlight-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .recruiter-report-hero {\n    padding: 20px;\n  }\n\n  .recruiter-report-title {\n    font-size: 24px;\n  }\n\n  .recruiter-report-summary-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .recruiter-snapshot-card {\n    grid-template-columns: auto 1fr;\n  }\n\n  .recruiter-rank-badge {\n    grid-column: 1 / -1;\n    width: fit-content;\n  }\n}\n\n@media (max-width: 575px) {\n  .recruiter-report-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
